import React, { useState, useEffect,useRef } from 'react';
import { ChevronDown, ChevronLeft,ChevronRight,
  CheckCircle,Calendar,Download,Share2,ExternalLink,
  User, Users,Pencil,
  ChevronUp, PlayCircle, FileText, Award, Book, Menu, X, Check, HelpCircle } from 'lucide-react';

import { FaTimes,FaPaperPlane } from 'react-icons/fa';

import custom_api_func from "./axios_api_func";
import {getCookie,getCsrfToken} from './get_csrfToken'
import LoadingScreen from './loadingscreen'
import { useParams } from 'react-router-dom'
import senteventdata from './sentdata_sg_analytics'
import toast, { Toaster } from 'react-hot-toast'
import CourseCompletionSurveys from './surveycomponent'


const CRMLearningAcademy = () => {
  const [activeTab, setActiveTab] = useState('courses');
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [loading,setloading] = useState(true);
  const [expandedSections, setExpandedSections] = useState({});
  const [selectedLesson, setSelectedLesson] = useState(null);
  const [courses, setCourses] = useState([]);
  const [showTest, setShowTest] = useState(false);
  const [testAnswers, setTestAnswers] = useState({});
  const [testSubmitted, setTestSubmitted] = useState(false);
  const [testScore, setTestScore] = useState(0);
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 768)
  const [showQuiz, setShowQuiz] = useState(false);
  const [currentQuiz, setCurrentQuiz] = useState(null);
  const [quizAnswers, setQuizAnswers] = useState({});
  const [quizSubmitted, setQuizSubmitted] = useState(false);
  const [quizScore, setQuizScore] = useState(0);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [showArticleEditor, setShowArticleEditor] = useState(false);
  const [editingArticle, setEditingArticle] = useState(null);
  const [articles, setArticles] = useState([]);
  const [articleForm, setArticleForm] = useState({
    title: '',
    category: '',
    content: '',
    readTime: '5 min read'
  });

  const introAudioRef = useRef(null);
  const audioRef = useRef(null);
  const iframeRef = useRef(null);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isTablet, setIsTablet] = useState(window.innerWidth > 768 && window.innerWidth <= 1024);
  

  var { academyid } = useParams()


  const [csrftoken,setcsrftoken] = useState(null)
    async function  fetch_csrf_token(){
      await getCsrfToken();
      setcsrftoken(getCookie('csrftoken'))
    }
  useEffect(() => {

    fetch_csrf_token()
    // eslint-disable-next-line
  }, []);


  useEffect(() => {

    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 768);
      setIsTablet(width > 768 && width <= 1024);
      setSidebarOpen(width > 768);

    };
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);

  }, []);

  const [user_name,set_user_name] = useState('N/A')
  const [user_email_id,set_user_email_id] = useState('N/A')

  useEffect(() => {
      Getalluserdetails()
        GetallCourses()
        GetallArticles()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


      const Getalluserdetails = () => {
            senteventdata('Getalluserdetails API Called React-js','')
            custom_api_func.get(`api/get_user_details_academy/${academyid}`)
                .then((response) => {
                    set_user_name(response.data.user_name);
                    set_user_email_id(response.data.user_email_id);
                    localStorage.setItem('useremail',response.data.user_email_id)
                    localStorage.setItem('user_name',response.data.user_name)
                }).catch((error) => {
                    //console.log("error", error);
                })
        }
    

  const GetallCourses = () => {
        senteventdata('GetallCourses API Called React-js','')
        
        custom_api_func.get(`api/get_all_courses/${academyid}`)
            .then((response) => {
                setCourses(response.data.results);
                                

                setloading(false)
            }).catch((error) => {
                //console.log("error", error);
                setloading(false)
            })
    }

  const GetallArticles = () => {
        senteventdata('GetallArticles API Called React-js','')
        custom_api_func.get(`api/get_all_articles`)
            .then((response) => {
                setArticles(response.data.results);
                
            }).catch((error) => {
                //console.log("error", error);
                
            })
    }

  
  const [allcertifications,setallcertifications] = useState([])
  const GetallCertifications = () => {
      senteventdata('get_all_certifications API Called React-js','')
      setloading(true)
      custom_api_func.get(`api/get_all_certifications`)
          .then((response) => {
              setallcertifications(response.data.results);
              setloading(false)
          }).catch((error) => {
              //console.log("error", error);
              setloading(false)
          })
  }

  const MyCertificates = ({ certifications, onDownload, onShare }) => {
  const [copiedId, setCopiedId] = useState(null);

  const copyShareLink = (shareUrl) => {
    console.log('shareUrl',shareUrl)
    navigator.clipboard.writeText(shareUrl);
    setCopiedId(shareUrl);
    setTimeout(() => setCopiedId(null), 2000);
  };

  if (!certifications || certifications.length === 0) {
    return (
      <div style={styles_2.emptyState}>
        <Award size={80} color="#9a9bab" />
        <h2 style={styles_2.emptyTitle}>No Certificates Yet</h2>
        <p style={styles_2.emptyDescription}>
          Complete courses and pass certification tests to earn your certificates
        </p>
      </div>
    );
  }

  return (
    <div style={styles_2.certificatesContainer}>
      <div style={styles_2.certificatesHeader}>
        <h2 style={styles_2.certificatesTitle}>My Certificates</h2>
        <p style={styles_2.certificatesSubtitle}>
          {certifications.length} {certifications.length === 1 ? 'Certificate' : 'Certificates'} Earned
        </p>
      </div>

      <div style={styles_2.certificatesGrid}>
        {certifications.map((cert) => (
          <div key={cert.id} style={styles_2.certCard}>
            <div style={styles_2.certCardHeader}>
              <div style={styles_2.certBadge}>
                <Award size={40} color="#7c3aed" />
              </div>
              <div style={styles_2.certVerified}>
                <CheckCircle size={16} color="#059669" />
                <span>Verified</span>
              </div>
            </div>

            <div style={styles_2.certCardBody}>
              <h3 style={styles_2.certCourseName}>{cert.certification_course_name}</h3>
              
              <div style={styles_2.certDetails}>
                <div style={styles_2.certDetail}>
                  <Calendar size={16} color="#5c5d70" />
                  <span>Earned: {cert.created_on}</span>
                </div>
                <div style={styles_2.certDetail}>
                  <Award size={16} color="#5c5d70" />
                  <span>Score: {cert.score}%</span>
                </div>
              </div>

              
            </div>

            <div style={styles_2.certCardFooter}>
              <button
                style={styles_2.downloadBtn}
                onClick={() => {
                  
                  onDownload(cert.certification_course_name,
                    cert.score,
                    cert.created_on,
                    cert.public_id
                  )
                }}
              >
                <Download size={16} />
                Download
              </button>
              
              <button
                style={styles_2.shareBtn}
                onClick={() => copyShareLink(`https://academy.successguardian.in/verify/${cert.public_id}`)}
              >
                {copiedId === `https://academy.successguardian.in/verify/${cert.public_id}` ? (
                  <>
                    <Check size={16} />
                    Copied!
                  </>
                ) : (
                  <>
                    <Share2 size={16} />
                    Share Link
                  </>
                )}
              </button>
              
              <button
                style={styles_2.viewBtn}
                onClick={() => window.open(`/verify/${cert.public_id}`, '_blank')}
              >
                <ExternalLink size={16} />
                View Public
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

    

  
  useEffect(() => {
    // Preload the intro music when component first mounts
    const audio = new Audio('https://api.successguardian.in/media/SG_Courses/intro_music.mp3');
    audio.preload = 'auto';
    audio.volume = 0.7;
    audio.load(); // Force loading
    introAudioRef.current = audio;
    
    return () => {
      if (introAudioRef.current) {
        introAudioRef.current.pause();
        introAudioRef.current = null;
      }
    };
  }, []);





  const toggleSection = (sectionId) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };

  const calculateProgress = (course) => {
    let totalLessons = 0;
    let completedLessons = 0;
    
    course.sections.forEach(section => {
      totalLessons += section.lessons.length;
      completedLessons += section.lessons.filter(l => l.completed).length;
    });
    
    return totalLessons > 0 ? Math.round((completedLessons / totalLessons) * 100) : 0;
  };

  const markLessonComplete = (courseId, lessonId) => {
    console.log('called')
  setCourses(prevCourses => {
    const updatedCourses = prevCourses.map(course => {
      if (course.id === courseId) {
        return {
          ...course,
          sections: course.sections.map(section => ({
            ...section,
            lessons: section.lessons.map(lesson =>
              lesson.id === lessonId
                ? { ...lesson, completed: true }
                : lesson
            )
          }))
        };
      }
      return course;
    });

    // get the updated course here
    const updatedCourse = updatedCourses.find(c => c.id === courseId);

    // Send API request **inside** the updater; you have correct data here

        
    const formData = new FormData();
    formData.append("progress", updatedCourse.progress);
    formData.append("sections", JSON.stringify(updatedCourse.sections));

    custom_api_func
      .post(`api/save_courses_update_video_or_quiz/${selectedCourse.id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "X-CSRFToken": csrftoken
        }
      })
      .catch(error => {
        console.log("markLessonComplete error", error);
      });

    return updatedCourses;
  });
};


  const [certificationEarned, setCertificationEarned] = useState({});
  const [certification_p_id, set_certification_p_id] = useState(null);


  const handleTestSubmit = () => {
  const questions = selectedCourse.certificationTest.questions_;
  let correct = 0;
  questions.forEach(q => {
    if (testAnswers[q.id] === q.correctAnswer) correct++;
  });
  const score = Math.round((correct / questions.length) * 100);
  setTestScore(score);
  setTestSubmitted(true);
  
  // Save certification if passed
  if (score >= selectedCourse.certificationTest.passingScore) {
    setCertificationEarned({
      ...certificationEarned,
      [selectedCourse.id]: {
        courseName: selectedCourse.title,
        date: new Date().toLocaleDateString(),
        score: score
      }
    });

    setCourses(prevCourses => {
    const updatedCourses = prevCourses.map(course => {
      if (course.id === selectedCourse.id) {
        return {
          ...course,
          certificationTest: {
            ...course.certificationTest,
            test_answers:testAnswers,
          test_score:score
        }
      }
    }
      return course;
    });

    // get the updated course here
    const updatedCourse = updatedCourses.find(c => c.id === selectedCourse.id);

    // Send API request **inside** the updater; you have correct data here
    const formData = new FormData();
    formData.append("progress", updatedCourse.progress);
    formData.append("sections", JSON.stringify(updatedCourse.sections));
    formData.append("test_answers", JSON.stringify(updatedCourse.certificationTest.test_answers));
    formData.append("test_score", JSON.stringify(updatedCourse.certificationTest.test_score));
    
    custom_api_func
      .post(`api/save_certifications/${selectedCourse.id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "X-CSRFToken": csrftoken
        }
      }).then((response) => {
        console.log('response.data',response.data)
        set_certification_p_id(response.data['certification_id'])
      })
      .catch(error => {
        console.log("handleQuizSubmit error", error);
      });

    return updatedCourses;
  });

  }
};

const downloadCertificate = (courseName_xx,score_xx,completion_date_xx,certification_p_id_xx) => {
  const canvas = document.createElement('canvas');
  canvas.width = 1600;
  canvas.height = 1200;
  const ctx = canvas.getContext('2d');
  
  // Cream background
  ctx.fillStyle = '#FFF8F0';
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  // Decorative corner ornaments
  const drawOrnament = (x, y, rotation) => {
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(rotation);
    ctx.strokeStyle = '#D4AF37';
    ctx.lineWidth = 3;
    ctx.lineCap = 'round';
    
    // Decorative flourish
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.quadraticCurveTo(30, -10, 50, 0);
    ctx.moveTo(0, 0);
    ctx.quadraticCurveTo(30, 10, 50, 0);
    ctx.moveTo(50, 0);
    ctx.lineTo(70, 0);
    ctx.stroke();
    
    ctx.restore();
  };

  // Draw corner ornaments
  drawOrnament(100, 100, 0);
  drawOrnament(canvas.width - 100, 100, Math.PI / 2);
  drawOrnament(canvas.width - 100, canvas.height - 100, Math.PI);
  drawOrnament(100, canvas.height - 100, -Math.PI / 2);

  // Outer border - gold
  ctx.strokeStyle = '#D4AF37';
  ctx.lineWidth = 8;
  ctx.strokeRect(60, 60, canvas.width - 120, canvas.height - 120);

  // Inner border - darker gold
  ctx.strokeStyle = '#B8941E';
  ctx.lineWidth = 2;
  ctx.strokeRect(80, 80, canvas.width - 160, canvas.height - 160);

  // Decorative middle border
  ctx.strokeStyle = '#D4AF37';
  ctx.lineWidth = 1;
  ctx.setLineDash([10, 5]);
  ctx.strokeRect(70, 70, canvas.width - 140, canvas.height - 140);
  ctx.setLineDash([]);

  // Top decorative band


  // Award seal/badge
  const drawSeal = (x, y, radius) => {
    ctx.save();
    ctx.translate(x, y);
    
    // Outer circle
    ctx.fillStyle = '#D4AF37';
    ctx.beginPath();
    ctx.arc(0, 0, radius, 0, Math.PI * 2);
    ctx.fill();
    
    // Inner circle
    ctx.fillStyle = '#B8941E';
    ctx.beginPath();
    ctx.arc(0, 0, radius - 8, 0, Math.PI * 2);
    ctx.fill();
    
    // Star points
    ctx.fillStyle = '#D4AF37';
    for (let i = 0; i < 8; i++) {
      const angle = (Math.PI * 2 * i) / 8;
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.lineTo(
        Math.cos(angle) * radius * 1.3,
        Math.sin(angle) * radius * 1.3
      );
      ctx.lineTo(
        Math.cos(angle + Math.PI / 8) * radius,
        Math.sin(angle + Math.PI / 8) * radius
      );
      ctx.closePath();
      ctx.fill();
    }
    
    // Center
    ctx.fillStyle = '#FFF8F0';
    ctx.beginPath();
    ctx.arc(0, 0, radius - 20, 0, Math.PI * 2);
    ctx.fill();
    
    // Checkmark
    ctx.strokeStyle = '#D4AF37';
    ctx.lineWidth = 8;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.beginPath();
    ctx.moveTo(-15, 0);
    ctx.lineTo(-5, 10);
    ctx.lineTo(15, -10);
    ctx.stroke();
    
    ctx.restore();
  };

  drawSeal(canvas.width / 2, 915, 60);

  // Title
  ctx.fillStyle = '#2C3E50';
  ctx.textAlign = 'center';
  ctx.font = 'bold 72px Georgia, serif';
  ctx.fillText('CERTIFICATE', canvas.width / 2, 280);
  
  ctx.font = '42px Georgia, serif';
  ctx.fillStyle = '#5D6D7E';
  ctx.fillText('of Achievement', canvas.width / 2, 340);

  // Decorative line under title
  ctx.strokeStyle = '#D4AF37';
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.moveTo(canvas.width / 2 - 200, 370);
  ctx.lineTo(canvas.width / 2 + 200, 370);
  ctx.stroke();

  // "This certifies that"
  ctx.font = 'italic 32px Georgia, serif';
  ctx.fillStyle = '#5D6D7E';
  ctx.fillText('This is to certify that', canvas.width / 2, 450);

  // Recipient name with underline
  ctx.font = 'bold 56px Brush Script MT, cursive';
  ctx.fillStyle = '#2C3E50';
  ctx.fillText(`${localStorage.getItem('user_name') || 'This Person'}`, canvas.width / 2, 540);
  
  // Name underline
  ctx.strokeStyle = '#D4AF37';
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(canvas.width / 2 - 250, 560);
  ctx.lineTo(canvas.width / 2 + 250, 560);
  ctx.stroke();

  // "has successfully completed"
  ctx.font = 'italic 28px Georgia, serif';
  ctx.fillStyle = '#5D6D7E';
  ctx.fillText('has successfully completed the course', canvas.width / 2, 630);

  // Course name with text wrapping
  ctx.fillStyle = '#2C3E50';
  const courseName = courseName_xx;
  const maxWidth = canvas.width - 600;
  let fontSize = 48;
  ctx.font = `bold ${fontSize}px Georgia, serif`;
  
  // Reduce font size if text is too long
  while (ctx.measureText(courseName).width > maxWidth && fontSize > 28) {
    fontSize -= 2;
    ctx.font = `bold ${fontSize}px Georgia, serif`;
  }
  
  // Wrap text if still too long
  const words = courseName.split(' ');
  const lines = [];
  let currentLine = words[0];
  
  for (let i = 1; i < words.length; i++) {
    const testLine = currentLine + ' ' + words[i];
    const metrics = ctx.measureText(testLine);
    
    if (metrics.width > maxWidth) {
      lines.push(currentLine);
      currentLine = words[i];
    } else {
      currentLine = testLine;
    }
  }
  lines.push(currentLine);
  
  // Draw course name lines centered
  const lineHeight = fontSize + 10;
  const startY = 710 - ((lines.length - 1) * lineHeight) / 2;
  
  lines.forEach((line, index) => {
    ctx.fillText(line, canvas.width / 2, startY + (index * lineHeight));
  });

  // Score banner
  ctx.fillStyle = '#D4AF37';
  ctx.fillRect(canvas.width / 2 - 150, 760, 300, 60);
  ctx.strokeStyle = '#B8941E';
  ctx.lineWidth = 2;
  ctx.strokeRect(canvas.width / 2 - 150, 760, 300, 60);
  
  ctx.fillStyle = '#FFF8F0';
  ctx.font = 'bold 32px Arial';
  ctx.fillText(`Score: ${score_xx}%`, canvas.width / 2, 800);

  // Date
  ctx.font = '26px Georgia, serif';
  ctx.fillStyle = '#5D6D7E';
  ctx.fillText(`Completion Date: ${completion_date_xx}`, canvas.width / 2, 1020);

  // Signature section
  const signatureY = 1080;
  
  // Signature line (left side for signature)
  ctx.strokeStyle = '#2C3E50';
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(canvas.width / 2 - 200, signatureY);
  ctx.lineTo(canvas.width / 2 + 200, signatureY);
  ctx.stroke();

  // Signature (handwriting style)
  ctx.font = 'italic bold 32px Brush Script MT, cursive';
  ctx.fillStyle = '#2C3E50';
  ctx.fillText('Rahul Choudhary', canvas.width / 2, signatureY - 10);
  
  ctx.font = '18px Georgia, serif';
  ctx.fillStyle = '#5D6D7E';
  ctx.fillText('Founder, SuccessGuardian', canvas.width / 2, signatureY + 30);

  // Verification section in bottom right corner
  if (certification_p_id_xx!=null){  

ctx.textAlign = 'right';
    ctx.font = '18px Georgia, serif';
    ctx.fillStyle = '#5D6D7E';
    ctx.fillText('Verify this certificate at:', canvas.width - 100, 1030);

    // Smart URL wrapping function that breaks at slashes and hyphens
    function wrapURL(ctx, text, x, y, maxWidth, lineHeight) {
      const lines = [];
      let currentLine = '';
      
      // Split URL into segments at natural break points
      const segments = text.split(/(?=\/)|(?=-)/); // Split before / and -
      
      for (let segment of segments) {
        const testLine = currentLine + segment;
        const testWidth = ctx.measureText(testLine).width;
        
        if (testWidth > maxWidth && currentLine !== '') {
          lines.push(currentLine);
          currentLine = segment;
        } else {
          currentLine = testLine;
        }
      }
      
      if (currentLine) {
        lines.push(currentLine);
      }
      
      // If any line is still too long, force break it
      const finalLines = [];
      for (let line of lines) {
        if (ctx.measureText(line).width > maxWidth) {
          let chars = '';
          for (let char of line) {
            const test = chars + char;
            if (ctx.measureText(test).width > maxWidth && chars !== '') {
              finalLines.push(chars);
              chars = char;
            } else {
              chars = test;
            }
          }
          if (chars) finalLines.push(chars);
        } else {
          finalLines.push(line);
        }
      }
      
      // Draw all lines
      finalLines.forEach((line, index) => {
        ctx.fillText(line, x, y + (index * lineHeight));
      });
    }

    ctx.font = 'bold 14px "Courier New", monospace';
    ctx.fillStyle = '#3498DB';

    const url = `https://academy.successguardian.in/verify/${certification_p_id_xx}`;
    const maxWidth = 400;

    wrapURL(ctx, url, canvas.width - 100, 1055, maxWidth, 20);


  }
  
  // Reset text align for potential future use
  ctx.textAlign = 'center';

  // Load and draw logo, then download
  const logo = new Image();
  logo.crossOrigin = 'anonymous';
  logo.onload = () => {
    // Calculate dimensions to maintain aspect ratio
    const maxLogoWidth = 300;
    const maxLogoHeight = 300;
    let logoWidth = logo.width;
    let logoHeight = logo.height;
    
    // Scale down if needed while maintaining aspect ratio
    if (logoWidth > maxLogoWidth || logoHeight > maxLogoHeight) {
      const ratio = Math.min(maxLogoWidth / logoWidth, maxLogoHeight / logoHeight);
      logoWidth = logoWidth * ratio;
      logoHeight = logoHeight * ratio;
    }
    
    // Draw logo at top center
    ctx.drawImage(logo, canvas.width / 2 - logoWidth / 2, 80, logoWidth, logoHeight);
    
    // Proceed with download after logo is loaded
    finalizeDownload();
  };
  
  logo.onerror = () => {
    // If logo fails to load, add text logo instead
    ctx.font = 'bold 48px Arial';
    ctx.fillStyle = '#D4AF37';
    ctx.fillText('SG', canvas.width / 2, 200);
    
    // Proceed with download
    finalizeDownload();
  };
  
  // Set logo source (replace with actual logo URL)
  logo.src = 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,fit=crop,q=95/YBgo20EJ2RtlGGKa/logo_6x-YNqMMbpOaviQv1ER.png';
  
  function finalizeDownload() {
    // Convert to image and download
    canvas.toBlob(blob => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${courseName_xx.replace(/\s+/g, '_')}_Certificate.png`;
      link.click();
      URL.revokeObjectURL(url);
    });
  }
};

  const handleQuizSubmit = () => {
    const questions = currentQuiz.questions;
    let correct = 0;
    questions.forEach(q => {
      if (quizAnswers[q.id] === q.correctAnswer) correct++;
    });
    const score = Math.round((correct / questions.length) * 100);
    setQuizScore(score);
    setQuizSubmitted(true);

    setCourses(prevCourses => {
    const updatedCourses = prevCourses.map(course => {
      if (course.id === selectedCourse.id) {
        return {
          ...course,
          sections: course.sections.map(section => ({
            ...section,
            lessons: section.lessons.map(lesson =>
              lesson.id === currentQuiz.id
                ? { ...lesson, completed: true, score:score,quiz_answers:quizAnswers }
                : lesson
            )
          }))
        };
      }
      return course;
    });

    // get the updated course here
    const updatedCourse = updatedCourses.find(c => c.id === selectedCourse.id);

    // Send API request **inside** the updater; you have correct data here
    const formData = new FormData();
    formData.append("progress", updatedCourse.progress);
    formData.append("sections", JSON.stringify(updatedCourse.sections));

    custom_api_func
      .post(`api/save_courses_update_video_or_quiz/${selectedCourse.id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "X-CSRFToken": csrftoken
        }
      })
      .catch(error => {
        console.log("handleQuizSubmit error", error);
      });

    return updatedCourses;
  });

  };

  const startTest = () => {
    setShowTest(true);
    setTestAnswers({});
    setTestSubmitted(false);
    setTestScore(0);
  };

  const startQuiz = (lesson) => {
    setCurrentQuiz(lesson);
    setShowQuiz(true);
    setQuizAnswers({});
    setQuizSubmitted(false);
    setQuizScore(0);
    setSelectedLesson(null);
  };

  const closeQuiz = () => {
    if (quizSubmitted && quizScore >= 70) {
      markLessonComplete(selectedCourse.id, currentQuiz.id);
    }
    setShowQuiz(false);
    setCurrentQuiz(null);
    setQuizAnswers({});
    setQuizSubmitted(false);
    setQuizScore(0);
  };

  const handleCreateArticle = () => {
    setShowArticleEditor(true);
    setEditingArticle(null);
    setSelectedArticle(null);
    setArticleForm({
      title: '',
      category: '',
      content: '',
      readTime: '5 min read'
    });
  };

  const handleEditArticle = (article) => {
    setShowArticleEditor(true);
    setEditingArticle(article);
    setSelectedArticle(null);
    setArticleForm({
      title: article.title,
      category: article.category,
      content: article.content || '',
      readTime: article.readTime
    });
  };

  const handleSaveArticle = () => {
    if (!articleForm.title || !articleForm.category || !articleForm.content) {
      alert('Please fill in all fields');
      return;
    }

    if (editingArticle) {
      setArticles(articles.map(a => 
        a.id === editingArticle.id 
          ? { ...a, ...articleForm }
          : a
      ));
    } else {
      const newArticle = {
        id: articles.length + 1,
        ...articleForm
      };
      setArticles([...articles, newArticle]);
    }
    
    setShowArticleEditor(false);
    setEditingArticle(null);
    setArticleForm({
      title: '',
      category: '',
      content: '',
      readTime: '5 min read'
    });
  };

  const handleDeleteArticle = (articleId) => {
    if (window.confirm('Are you sure you want to delete this article?')) {
      setArticles(articles.filter(a => a.id !== articleId));
      setSelectedArticle(null);
    }
  };

  useEffect(() => {
    if (selectedCourse) {
      const updatedCourse = courses.find(c => c.id === selectedCourse.id);
      setSelectedCourse(updatedCourse);
    }
  }, [courses]);

  const handleSupportClick = () => {
    setShowSupportModal(true);
    setSubmitSuccess(false);
  };

  const [showSupportModal, setShowSupportModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [hoveredClose, setHoveredClose] = useState(false);
  const [focusedField, setFocusedField] = useState(null);
  const [hoveredSubmit, setHoveredSubmit] = useState(false);

  const [ticketForm, setTicketForm] = useState({
    subject: '',
    category: '',
    priority: 'medium',
    description: ''
  });

  const handleCloseModal = () => {
    setShowSupportModal(false);
    setTicketForm({
      subject: '',
      category: '',
      priority: 'medium',
      description: ''
    });
    setSubmitSuccess(false);
  };

  const handleFormChange = (field, value) => {
    setTicketForm(prev => ({
      ...prev,
      [field]: value
    }));
  };
  
  const isFormValid = ticketForm.subject.trim() && ticketForm.category && ticketForm.description.trim();

  const handleSubmitTicket = async () => {
    if (!isFormValid) return;
    
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("subject", ticketForm.subject);
    formData.append("describesub", ticketForm.description);
    formData.append("category", ticketForm.category);
    formData.append("priority", ticketForm.priority);

    custom_api_func.post("helpcenter/", formData, {headers: { "Content-Type": "multipart/form-data",'X-CSRFToken': csrftoken,},})
      .then((response) => {
          //console.log(response);
          setIsSubmitting(false);
          setSubmitSuccess(true);
          handleCloseModal()
          toast.success('Ticket Submitted. We will reachout to you soon with a solution')

      })
      .catch((error) => {
          //console.log(error);
      });


  };

  const Sidebar = () => (
    <div style={{
      ...styles.sidebar,
      ...(isMobile ? {
        position: 'fixed',
        left: sidebarOpen ? 0 : '-260px',
        top: 0,
        bottom: 0,
        zIndex: 1000,
        transition: 'left 0.3s ease'
      } : {})
    }}>
      <div style={styles.sidebarHeader}>
        <div style={styles.logo}>
          <div style={styles.logoIcon}><img style={{height:"30px",width:"30px"}} src="logo_sg_small.png" ></img></div>
          <span style={styles.logoText}>SucccessGuardian</span>
        </div>
         {isMobile && (
          <button 
            onClick={() => setSidebarOpen(false)}
            style={styles.closeSidebarBtn}
          >
           <X size={24} />
          </button>

        )}
      </div>

      <nav style={styles.nav}>
        <div 
          style={{...styles.navItem, ...(activeTab === 'courses' ? styles.navItemActive : {})}}
          onClick={() => {
            setActiveTab('courses');
            setSelectedCourse(null);
            set_certification_p_id(null) 
            setShowTest(false);
            if (isMobile) setSidebarOpen(false);
            setSelectedArticle(null);
            setShowArticleEditor(false);
          }}
        >
          <Book size={20} />
          <span>Home</span>
        </div>
        <div 
        style={{...styles.navItem, ...(activeTab === 'certificates' ? styles.navItemActive : {})}}
        onClick={() => {
          GetallCertifications()
          if (isMobile) setSidebarOpen(false);
          setActiveTab('certificates')
        }}
        >
          <Award size={20} />
          <span>My Certificates</span>
        </div>
      </nav>

      <div style={styles.sidebarFooter}>
        <div 
        onClick={() => {
           window.location.href = "mailto:successacademy@successguardian.in?subject=Support%20Request";
        }}
        style={styles.navItem}>
          <HelpCircle style={{ color: "white", width: '20px', height: '20px' }} />
          <span>Support</span>
        </div>
      </div>

    </div>
  );

const CoursesList = () => {
  const [searchTerm, setSearchTerm] = React.useState('');
  const [selectedCategory, setSelectedCategory] = React.useState('All');

  const filteredCourses = courses.filter(course => {
    const matchesSearch = course.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         course.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = selectedCategory === 'All' || course.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  return (
    <div>
      {/* Search and Filter Section */}
      <div style={styles.filterContainer}>
        <input
          type="text"
          placeholder="Search courses..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={styles.searchInput}
        />
        
        <div style={styles.categoryTabs}>
          {['All', 'Customer Success Courses', 'SuccessGuardian Customer Success Platform Courses'].map(category => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              style={{
                ...styles.categoryTab,
                ...(selectedCategory === category ? styles.categoryTabActive : {})
              }}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      {/* Courses Grid */}
      <div style={styles.coursesGrid}>
        {filteredCourses.map(course => (
          <div 
            key={course.id} 
            style={styles.courseCard}
            
          >
            <div style={styles.courseCardHeader}>
              <div style={styles.courseIcon}>
                {course.thumbnail ? (
                  <img
                    src={course.thumbnail}
                    alt=""
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                ):(
                  <>
                  ☁️
                  </>
                )}
                </div>
              <div style={styles.courseProgress}>{calculateProgress(course)}%</div>
            </div>
            <h3 style={styles.courseTitle}>{course.title}</h3>
            <p style={styles.courseDescription}>{course.description}</p>
            <div style={styles.courseFooter}>
              <span style={styles.courseDuration}>⏱ {course.duration}</span>
              <span style={styles.courseSections}>{course.sections.length} sections</span>
            </div>
            <div
             style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            >
             <button
            onClick={() => {
              setSelectedCourse(course);
              setShowTest(false);
              setExpandedSections({ [course.sections[0].id]: true });
            }}
            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#402855'; }}
            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#7c3aed'; }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              width:"min(220px, 100%)",
              marginTop: '20px',
              padding: '10px 24px',
              backgroundColor: '#7c3aed',
              color: '#fff',
              fontWeight: 500,
              fontSize: '15px',
              fontFamily: 'inherit',
              border: 'none',
              borderRadius: '9999px',
              cursor: 'pointer',
              transition: 'background-color 0.2s ease',
            }}
          >
            <span style={{ fontSize: '11px', lineHeight: 1 }}>▶</span>
            <span>Access</span>
          </button>
          </div>
          </div>
        ))}
      </div>
      
      {filteredCourses.length === 0 && (
        <div style={styles.noResults}>No courses found</div>
      )}
    </div>
  );
};

  const [currentLessonIndex, setCurrentLessonIndex] = useState(0);
  const [currentSectionLessons, setCurrentSectionLessons] = useState([]);

const [showIntro, setShowIntro] = useState(false);
const [introAudio, setIntroAudio] = useState(null);
const [currentLessonId, setCurrentLessonId] = useState(null);

// Separate Intro Component
// Separate Intro Component
const IntroScreen = ({ lesson, sectionNumber, sectionTitle, onComplete, preloadedAudio }) => {
  useEffect(() => {
    // Use the preloaded audio instead of creating a new one
    const audio = preloadedAudio;
    
    if (audio) {
      // Reset audio to beginning
      audio.currentTime = 0;
      
      // Play the preloaded audio
      const playPromise = audio.play();
      if (playPromise !== undefined) {
        playPromise.catch(err => {
          console.log('Audio play prevented:', err.message);
          // If autoplay is blocked, continue without audio
        });
      }
    }
    
    // Auto-complete after 4 seconds 
    const timer = setTimeout(() => {
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
      }
      onComplete();
    }, 3000);
    
    // Cleanup - pause but don't destroy the preloaded audio
    return () => {
      clearTimeout(timer);
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
      }
    };
  }, [onComplete, preloadedAudio]);

  return (
    <div style={styles.videoPlayerContainer}>
      <div style={styles.introOverlay}>
        <LessonIntro 
          lessonTitle={lesson.title}
          sectionNumber={sectionNumber}
          sectionTitle={sectionTitle}
        />
      </div>
    </div>
  );
};


// Separate Video Component
const VideoPlayer = ({ course, lesson, onSelectLesson, onComplete }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showingIntro, setShowingIntro] = useState(true);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Re-show the intro every time the lesson changes
  useEffect(() => {
    setShowingIntro(true);
  }, [lesson.id]);

  // Flatten course into an ordered lesson list with section metadata
  const allLessons = React.useMemo(() => {
    const list = [];
    course.sections.forEach((section, sIdx) => {
      section.lessons.forEach(l => {
        list.push({ ...l, sectionNumber: sIdx + 1, sectionTitle: section.title });
      });
    });
    return list;
  }, [course]);

  const currentIndex = allLessons.findIndex(l => l.id === lesson.id);
  const currentLesson = allLessons[currentIndex] || lesson;
  const hasPrevious = currentIndex > 0;
  const hasNext = currentIndex < allLessons.length - 1;

  const goToPrevious = () => hasPrevious && onSelectLesson(allLessons[currentIndex - 1]);
  const goToNext = () => hasNext && onSelectLesson(allLessons[currentIndex + 1]);

  const handleComplete = () => {
    onComplete?.(lesson);
    if (hasNext) goToNext();
  };

  // Show the lesson intro screen before the video itself
  if (showingIntro) {
    return (
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
        minWidth: 0,
      }}>
        <IntroScreen
          lesson={currentLesson}
          sectionNumber={currentLesson.sectionNumber}
          sectionTitle={currentLesson.sectionTitle}
          onComplete={() => setShowingIntro(false)}
          preloadedAudio={introAudioRef.current}
        />
      </div>
    );
  }

  return (
    <div style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      minHeight: 0, // lets the video area shrink/scroll instead of overflowing
      minWidth: 0,
    }}>
      {/* Header */}
      <div style={{
        padding: 'clamp(12px, 3vw, 20px) clamp(16px, 4vw, 32px)',
        borderBottom: '1px solid #e5e7eb',
        background: '#fff',
        flexShrink: 0,
      }}>
        <div style={{ fontSize: 12, color: '#9ca3af', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
          Section {currentLesson.sectionNumber} · {currentLesson.sectionTitle}
        </div>
        <div style={{ fontSize: 'clamp(16px, 4vw, 20px)', fontWeight: 700, color: '#111827', marginTop: 4 }}>
          {currentLesson.title}
        </div>
      </div>

      {/* Video area */}
      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#111827',
        padding: 'clamp(10px, 3vw, 24px)',
        minHeight: 0,
        minWidth: 0,
      }}>
        <video
          key={lesson.id}
          controls
          controlsList="nodownload"
          preload="auto"
          style={{
            width: '100%',
            height: '100%',
            maxWidth: 1100,
            maxHeight: '100%',
            borderRadius: 10,
            background: '#000',
            objectFit: 'contain',
          }}
        >
          <source src={lesson.url} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      {/* Info + controls */}
      <div style={{
        flexShrink: 0,
        background: '#fff',
        borderTop: '1px solid #e5e7eb',
        padding: 'clamp(10px, 3vw, 16px) clamp(16px, 4vw, 32px)',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
      }}>
        <div style={{ fontSize: 13, color: '#6b7280' }}>
          Duration: {currentLesson.duration} · Lesson {currentIndex + 1} of {allLessons.length}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
          <button
            onClick={goToPrevious}
            disabled={!hasPrevious}
            style={{
              display: 'flex', alignItems: 'center', gap: 6,
              padding: '8px 14px', borderRadius: 8, fontSize: 14, fontWeight: 500,
              border: '1px solid #e5e7eb', background: '#fff',
              color: hasPrevious ? '#374151' : '#d1d5db',
              cursor: hasPrevious ? 'pointer' : 'not-allowed',
            }}
          >
            <ChevronLeft size={16} />
            {!isMobile && 'Previous'}
          </button>

          <button
            onClick={() => {
            markLessonComplete(selectedCourse.id, selectedLesson.id);
            if (hasNext) {
              goToNext();
            } else {
              setSelectedLesson(null);
            }
          }}
            style={{
              display: 'flex', alignItems: 'center', gap: 6,
              padding: '8px 16px', borderRadius: 8, fontSize: 14, fontWeight: 600,
              border: 'none', background: '#1e1b3a', color: '#fff', cursor: 'pointer',
            }}
          >
            <Check size={16} />
            Complete
          </button>

          <button
            onClick={goToNext}
            disabled={!hasNext}
            style={{
              display: 'flex', alignItems: 'center', gap: 6,
              padding: '8px 14px', borderRadius: 8, fontSize: 14, fontWeight: 500,
              border: '1px solid #e5e7eb', background: '#fff',
              color: hasNext ? '#374151' : '#d1d5db',
              cursor: hasNext ? 'pointer' : 'not-allowed',
            }}
          >
            {!isMobile && 'Next'}
            <ChevronRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

const LessonIntro = ({ lessonTitle, sectionNumber, sectionTitle }) => {
  return (
    <div style={styles.introContainer}>
      <div style={styles.introParticles}>
        {[...Array(6)].map((_, i) => (
          <div key={i} style={{...styles.particle, ...styles[`particle${i + 1}`]}} />
        ))}
      </div>
      
      <div style={styles.introContent}>
        <div style={styles.introGlow} />
        <div style={styles.introLessonNumber}>
          Lesson {sectionNumber} : {sectionTitle}
        </div>
        <div style={styles.introLessonBox}>
          <div style={styles.introBorderBox} />
          <h1 style={styles.introLessonTitle}>{lessonTitle}</h1>
        </div>
      </div>
    </div>
  );
};


const CourseDetail = () => {
  const currentCourse = courses.find(c => c.id === selectedCourse.id);
  const progress = calculateProgress(currentCourse);
  const stackLayout = isMobile || isTablet;

  const [showSurvey, setShowSurvey] = useState(false);

  useEffect(() => {
    if (!currentCourse) return;

    const doneKey = `sg_survey_done_${currentCourse.id}`;
    const dismissedThisSessionKey = `sg_survey_dismissed_session_${currentCourse.id}`;

    const alreadyDone = !!localStorage.getItem(doneKey);
    const dismissedThisSession = sessionStorage.getItem(dismissedThisSessionKey) === '1';

    setShowSurvey(progress === 100 && !alreadyDone && !dismissedThisSession);
  }, [progress, currentCourse?.id]);

  const handleSurveyClose = () => {
    if (currentCourse) {
      // Remembers for the rest of THIS browser session (tab), even if progress recalculates
      sessionStorage.setItem(`sg_survey_dismissed_session_${currentCourse.id}`, '1');
      // Remembers permanently that it was shown/completed
      localStorage.setItem(`sg_survey_done_${currentCourse.id}`, '1');
    }
    setShowSurvey(false);
  };

  if (selectedLesson && !showTest && !showQuiz) {
    return (
      <LessonPlayer
        course={currentCourse}
        lesson={selectedLesson}
        onClose={() => setSelectedLesson(null)}
        onSelectLesson={(l) => {
          if (l.type === 'quiz') { startQuiz(l); } else { setSelectedLesson(l); }
        }}
      />
    );
  }

  return (
    <div style={{ padding: 'clamp(16px, 4vw, 24px) clamp(16px, 5vw, 40px)', maxWidth: 1400, margin: '0 auto', boxSizing: 'border-box' }}>
      <button
      onMouseEnter={(e) => { e.currentTarget.style.opacity = '0.8'; }}
      onMouseLeave={(e) => { e.currentTarget.style.opacity = '1'; }}
        style={{
          background: '#4A2E6B', border: '1px solid gray', color: '#fff',
          fontWeight: 600, fontSize: 14, cursor: 'pointer', marginBottom: 20, padding: 10,
          borderRadius:25,
        }}
        onClick={() => { setSelectedCourse(null); set_certification_p_id(null); setShowTest(false); }}
      >
        ← Back to Courses
      </button>

      {showQuiz && <SectionQuiz />}

      <div style={{ display: 'flex', flexDirection: stackLayout ? 'column' : 'row', gap: 'clamp(20px, 4vw, 32px)', alignItems: stackLayout ? 'stretch' : 'flex-start' }}>
        {/* LEFT: content + accordion */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <h1 style={{ fontSize: 'clamp(24px, 5vw, 32px)', fontWeight: 700, margin: '0 0 12px', color: '#111827' }}>
            {currentCourse.title}
          </h1>
          <p style={{ color: '#4b5563', fontSize: 15, lineHeight: 1.6, marginBottom: 32 }}>
            After watching all the course material and reinforcing your knowledge through practice quizzes,
            you'll complete an interactive assessment to test your learning, earn a certification and claim your spot.
          </p>

          <div>
           
            {progress === 100 && (
              <div style={{ marginTop: 24,marginBottom: 24 }}>
                <div style={{
                  border: '1px solid #e5e7eb', borderRadius: 16, padding: 'clamp(20px, 5vw, 32px)',
                  textAlign: 'center', background: '#faf5ff'
                }}>
                  <Award size={40} color="#7c3aed" />
                  <h3 style={{ fontSize: 20, fontWeight: 700, margin: '12px 0 8px', color: '#111827' }}>
                    You have completed all the lessons. Now you are Ready for Certification.
                  </h3>
                  <p style={{ color: '#4b5563', marginBottom: 20 }}>
                    Complete the {currentCourse.certificationTest.questions}-question assessment to earn your certification
                  </p>
                  <button
                    style={{
                      padding: '12px 28px', background: '#7c3aed', color: '#fff',
                      border: 'none', borderRadius: 8, fontWeight: 600, fontSize: 15, cursor: 'pointer'
                    }}
                    onClick={startTest}
                  >
                    Start Certification Test
                  </button>
                </div>
              </div>
            )}

             <div style={{
              display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'baseline', gap: 8, marginBottom: 12
            }}>
              <h2 style={{ fontSize: 22, fontWeight: 700, margin: 0, color: '#111827' }}>Course Content</h2>
              <span style={{ color: '#6b7280', fontSize: 14 }}>
                {currentCourse.sections.length} sections ·{' '}
                {currentCourse.sections.reduce((a, s) => a + s.lessons.length, 0)} lessons
                {currentCourse.duration ? ` · ${currentCourse.duration}` : ''}
              </span>
            </div>

            {currentCourse.sections.map((section, idx) => (
              <div
                key={section.id}
                style={{
                  border: '1px solid #e5e7eb', borderRadius: 12, marginBottom: 12,
                  overflow: 'hidden', background: '#fff'
                }}
              >
                <div
                  style={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    padding: 'clamp(14px, 3vw, 18px) clamp(14px, 3vw, 20px)', cursor: 'pointer',
                    background: expandedSections[section.id] ? '#7c3aed' : '#7c3aed',
                    gap: 12,
                  }}
                  onClick={() => toggleSection(section.id)}
                >
                  <h3 style={{ fontSize: 'clamp(14px, 3.5vw, 16px)', fontWeight: 600, margin: 0, color: '#fff', minWidth: 0 }}>
                    {idx + 1}. {section.title}
                  </h3>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
                    <span style={{ color: '#fff', fontSize: 13, whiteSpace: 'nowrap' }}>{section.lessons.length} lessons</span>
                    {expandedSections[section.id] ? <ChevronUp size={20} color='#fff'/> : <ChevronDown color='#fff' size={20} />}
                  </div>
                </div>

                {expandedSections[section.id] && (
                  <div>
                    {section.lessons.map((lesson, lIdx) => (
                      <div
                        key={lesson.id}
                        style={{
                          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                          padding: 'clamp(12px, 3vw, 14px) clamp(14px, 3vw, 20px)', borderTop: '1px dashed #e5e7eb', cursor: 'pointer',
                          gap: 12,
                        }}
                        onClick={() => {
                          if (lesson.type === 'video') { setSelectedLesson(lesson); setShowTest(false); setShowQuiz(false); }
                          else if (lesson.type === 'quiz') { startQuiz(lesson); setShowTest(false); }
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
                          <span style={{ color: '#9ca3af', fontSize: 14, minWidth: 32, flexShrink: 0 }}>{idx + 1}.{lIdx + 1}</span>
                          <span style={{ fontSize: 'clamp(13px, 3.5vw, 15px)', color: '#374151', overflowWrap: 'anywhere' }}>{lesson.title}</span>
                        </div>
                        {lesson.completed
                          ? <Check size={18} color="#059669" style={{flexShrink:0}} />
                          : (lesson.type === 'video'
                              ? <PlayCircle size={18} color="#7c3aed" style={{flexShrink:0}} />
                              : <FileText size={18} color="#7c3aed" style={{flexShrink:0}} />)}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}

            
          </div>

          {currentCourse.skills && (
            <div style={{ marginTop: 40 }}>
              <h2 style={{ fontSize: 22, fontWeight: 700, margin: '0 0 12px', color: '#111827' }}>
                Skills and Knowledge
              </h2>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                {currentCourse.skills.map((skill, i) => (
                  <span
                    key={i}
                    style={{
                      background: '#1e1b3a', color: '#fff', padding: '8px 14px',
                      borderRadius: 20, fontSize: 14
                    }}
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* RIGHT: sticky info card */}
        <div style={{
          width: stackLayout ? '100%' : 320, flexShrink: 0, borderRadius: 16, overflow: 'hidden',
          boxShadow: '0 4px 16px rgba(0,0,0,0.08)', background: '#fff',
          position: stackLayout ? 'static' : 'sticky', top: 24, boxSizing: 'border-box'
        }}>
          <div style={{
            height: 200,
            background: currentCourse.thumbnail ? undefined : 'linear-gradient(135deg,#1e1b3a,#312a5e)'
          }}>
            {currentCourse.thumbnail && (
              <img
                src={currentCourse.thumbnail}
                alt=""
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            )}
          </div>

          <div style={{ padding: 20 }}>
            <h3 style={{ fontSize: 18, fontWeight: 700, margin: '0 0 4px', color: '#111827' }}>
              {currentCourse.title}
            </h3>
            <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 16 }}>
              by {currentCourse.author || 'Instructor'}
            </p>

            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', fontSize: 14 }}>
              <span style={{ fontWeight: 600, color: '#111827' }}>Result</span>
              <span style={{ color: '#374151' }}>{progress === 100 ? 'Complete' : 'Incomplete'}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', fontSize: 14 }}>
              <span style={{ fontWeight: 600, color: '#111827' }}>Grade</span>
              <span style={{ color: '#374151' }}>{currentCourse.grade ?? 0}%</span>
            </div>

            <div style={{
              display: 'flex', alignItems: 'center', gap: 6, margin: '12px 0',
              color: '#6b7280', fontSize: 14
            }}>
              <Users size={16} /> <span>{currentCourse.enrolled ?? 1}</span>
            </div>

            <button
              style={{
                width: '100%', padding: '14px 0', background: '#1e1b3a', color: '#fff',
                border: 'none', borderRadius: 10, fontWeight: 600, fontSize: 15,
                cursor: 'pointer', marginTop: 8
              }}
              onClick={() => setSelectedLesson(currentCourse.sections[0].lessons[0])}
            >
              {progress > 0 ? 'Continue' : 'Get Started'}
            </button>
          </div>
        </div>
      </div>

      {showSurvey && (
        <CourseCompletionSurveys
          academyid={academyid}
          csrftoken={csrftoken}
          course={{ id: currentCourse.id, title: currentCourse.title }}
          onClose={handleSurveyClose}
        />
      )}

    </div>
  );
};

// ---------- Player layout (matches screenshot 2) ----------
const LessonPlayer = ({ course, lesson, onClose, onSelectLesson }) => {
  const totalLessons = course.sections.reduce((a, s) => a + s.lessons.length, 0);
  const completedLessons = course.sections.reduce(
    (a, s) => a + s.lessons.filter(l => l.completed).length, 0
  );
  const pct = Math.round((completedLessons / totalLessons) * 100);
  const [navOpen, setNavOpen] = useState(!isMobile);

  useEffect(() => {
    setNavOpen(!isMobile);
  }, [isMobile]);

  return (
    <div style={{ display: 'flex', height: '100vh', background: '#f3f4f6', position: 'relative', overflow: 'hidden' }}>
      {/* Overlay behind the nav drawer on mobile */}
      {isMobile && navOpen && (
        <div
          onClick={() => setNavOpen(false)}
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(10,10,20,0.5)', zIndex: 1099,
          }}
        />
      )}

      {/* Left nav */}
      <div style={{
        width: isMobile ? 'min(300px, 85vw)' : 300,
        flexShrink: 0, background: '#fff', padding: 20,
        overflowY: 'auto', borderRight: '1px solid #e5e7eb',
        boxSizing: 'border-box',
        ...(isMobile ? {
          position: 'fixed', top: 0, bottom: 0, left: navOpen ? 0 : '-100%',
          zIndex: 1100, transition: 'left 0.3s ease', height: '100vh',
          boxShadow: navOpen ? '4px 0 16px rgba(0,0,0,0.15)' : 'none',
        } : {})
      }}>
        <button
          style={{
            background: 'none', border: 'none', color: '#374151', fontWeight: 600,
            cursor: 'pointer', marginBottom: 20, textAlign: 'left', padding: 0, fontSize: 14
          }}
          onClick={onClose}
        >
          ⤴ Exit course
        </button>

        <div style={{ fontSize: 12, color: '#9ca3af' }}>Course</div>
        <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 8, color: '#111827' }}>{course.title}</div>
        <div style={{ height: 6, background: '#e5e7eb', borderRadius: 4, overflow: 'hidden' }}>
          <div style={{ height: '100%', width: `${pct}%`, background: '#1e1b3a' }} />
        </div>
        <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>{pct}%</div>

        {course.sections.map((section, idx) => (
          <div key={section.id} style={{ marginTop: 16 }}>
            <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 6, color: '#111827' }}>
              {idx + 1}. {section.title}
            </div>
            {section.lessons.map((l, lIdx) => (
              <div
                key={l.id}
                style={{
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                  padding: '10px 8px', borderRadius: 8, fontSize: 14, cursor: 'pointer',
                  color: l.id === lesson.id ? '#1e1b3a' : '#4b5563',
                  fontWeight: l.id === lesson.id ? 600 : 400,
                  background: l.id === lesson.id ? '#ede9fe' : 'transparent',
                  gap: 8,
                }}
                onClick={() => {
                  onSelectLesson(l);
                  if (isMobile) setNavOpen(false);
                }}
              >
                <span style={{ overflowWrap: 'anywhere', minWidth: 0 }}>{idx + 1}.{lIdx + 1} {l.title}</span>
                {l.completed && <Check size={16} color="#059669" style={{flexShrink:0}} />}
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* Right: hero + content */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        {isMobile && (
          <div style={{
            display: 'flex', alignItems: 'center', gap: 10,
            padding: '10px 16px', background: '#fff', borderBottom: '1px solid #e5e7eb', flexShrink: 0,
          }}>
            <button
              onClick={() => setNavOpen(true)}
              style={{
                display: 'flex', alignItems: 'center', gap: 6,
                padding: '8px 12px', borderRadius: 8, border: '1px solid #e5e7eb',
                background: '#fff', color: '#374151', fontSize: 13, fontWeight: 600, cursor: 'pointer',
              }}
            >
              <Menu size={16} /> Lessons
            </button>
          </div>
        )}

        <VideoPlayer
            course={course}
            lesson={lesson}
            onSelectLesson={onSelectLesson}
            onComplete={(l) => {/* mark l.id complete in your data layer, then re-render course */}}
          />

      </div>
    </div>
  );
};


const [showShareModal, setShowShareModal] = useState(false);
const [shareText, setShareText] = useState('');
const [copied, setCopied] = useState(false);


const buildLinkedInPost = (courseName, score, public_id) => {
  return `I’m happy to share that I’ve completed the "${courseName}" certification with a score of ${score}%.

Looking forward to applying what I’ve learned and continuing to grow.

${public_id ? `🔗 Certificate Public Link: https://academy.successguardian.in/verify/${public_id}` : ''}

 #Learning #SuccessAcademy #SuccessGuardian #CustomerSuccess`;
};


const downloadCertificate2 = (selectedCourse) => {



  custom_api_func.get(`api/getcoursecertificationinfo/${certification_p_id}/`)     
      .then((response) => {
          const public_id = response.data.public_id
          const courseName = selectedCourse.title
          const score = response.data.score

         downloadCertificate(courseName,
          score,
          certificationEarned[selectedCourse.id].date,
          public_id,
        )
      })
      .catch((error) => {
        toast.error('Error Occured. Go to My Certifications Section to download the Certification')
      })
  

}
const shareCertificatelinkedin = (selectedCourse) => {
custom_api_func.get(`api/getcoursecertificationinfo/${certification_p_id}/`)      
.then((response) => {
        const public_id = response.data.public_id
        const courseName = selectedCourse.title
        const score = response.data.score
        const post = buildLinkedInPost(courseName, score,public_id);
        setShareText(post);
        setShowShareModal(true);
        setCopied(false);
      })
      .catch((error) => {
        toast.error('Error Occured. Go to My Certifications Section to get the Certification')
      })

};

const handleCopy = async () => {
  try {
    await navigator.clipboard.writeText(shareText);
    setCopied(true);
  } catch (err) {
    console.error('Clipboard copy failed', err);
  }
};


  const CertificationTest = () => {
    const questions = selectedCourse.certificationTest.questions_;
    
    if (testSubmitted) {
      const passed = testScore >= selectedCourse.certificationTest.passingScore;
      
      return (
        <>
        <div style={styles.testResults}>
          <div style={styles.testResultsCard}>
            <Award size={80} color={passed ? '#059669' : '#e11d48'} />
            <h2 style={styles.testResultsTitle}>
              {passed ? 'Congratulations! 🎉' : 'Keep Learning!'}
            </h2>
            <div style={styles.testScore}>
              <span style={styles.testScoreNumber}>{testScore}%</span>
              <span style={styles.testScoreLabel}>Your Score</span>
            </div>
            <p style={styles.testResultsDescription}>
              {passed 
                ? `You've passed the certification test! You can now download your certificate.`
                : `You need ${selectedCourse.certificationTest.passingScore}% to pass. Review the course material and try again.`
              }
            </p>
            <div style={styles.testResultsActions}>
              <div style={{
                display:"flex",
                flexDirection:"column",
                gap:"8px",
                
                alignItems:"center",
                alignContent:"center",
                
              }}>
              {passed && (
                <>
                
                 <button 
                 onMouseEnter={(e) => { e.currentTarget.style.opacity = '0.7'; }}
                 onMouseLeave={(e) => { e.currentTarget.style.opacity = '1'; }}
                onClick={()=>{
                  shareCertificatelinkedin(selectedCourse)
                }}
                style={{...styles.downloadButton,background:"blue"}}>
                  Share the Good News over LinkedIn
                </button>

                <button 
                onMouseEnter={(e) => { e.currentTarget.style.opacity = '0.7'; }}
                 onMouseLeave={(e) => { e.currentTarget.style.opacity = '1'; }}
                onClick={()=>{
                  downloadCertificate2(selectedCourse)
                 
                }}
                style={styles.downloadButton}>
                  Download the Certificate
                </button>
                
                </>
              )}
              <button 
              onMouseEnter={(e) => { e.currentTarget.style.opacity = '0.7'; }}
                 onMouseLeave={(e) => { e.currentTarget.style.opacity = '1'; }}
                style={styles.secondaryButton}
                onClick={() => setShowTest(false)}
              >
                {passed ? 'Back to Course' : 'Review Course Material'}
              </button>
              {!passed && (
                <button 
                  style={styles.retakeButton}
                  onClick={startTest}
                >
                  Retake Test
                </button>
              )}
              </div>
            </div>
          </div>
        </div>
        {showShareModal && (
            <div style={styles.shareModalOverlay} onClick={() => setShowShareModal(false)}>
              <div style={styles.shareModalCard} onClick={(e) => e.stopPropagation()}>
                <h3 style={styles.shareModalTitle}>Share your achievement</h3>
                <p style={styles.shareModalSubtitle}>
                  Copy the post below, then head to LinkedIn and paste it into a new post.
                </p>

                <textarea
                  style={styles.shareTextArea}
                  value={shareText}
                  onChange={(e) => setShareText(e.target.value)}
                  rows={8}
                />

                <div
                style={{
                  display:"flex",
                  flexDirection:"column",
                  gap:"8px",
                  justifyContent:"center",
                  alignContent:"center"
                }}
                >
                <button 
                onMouseEnter={(e) => { e.currentTarget.style.opacity = '0.8'; }}
                onMouseLeave={(e) => { e.currentTarget.style.opacity = '1'; }}
                style={styles.linkedInButton} onClick={handleCopy}>
                  {copied ? '✓ Copied to clipboard' : 'Copy Post Text'}
                </button>

               

                <button 
                onMouseEnter={(e) => { e.currentTarget.style.opacity = '0.8'; }}
                onMouseLeave={(e) => { e.currentTarget.style.opacity = '1'; }}
                  style={styles.secondaryButton} 
                  onClick={() => setShowShareModal(false)}
                >
                  Close
                </button>
                </div>
              </div>
            </div>
          )}

        </>
      );
    }

    return (
      <div style={styles.testContainer}>
        <div style={styles.testHeader}>
          <h2 style={styles.testTitle}>Certification Assessment</h2>
          <p style={styles.testSubtitle}>
            {questions.length} Questions • Passing Score: {selectedCourse.certificationTest.passingScore}%
          </p>
        </div>

        <div style={styles.questionsContainer}>
          {questions.map((q, index) => (
            <div key={q.id} style={styles.questionCard}>
              <h3 style={styles.questionText}>
                {index + 1}. {q.question}
              </h3>
              <div style={styles.optionsContainer}>
                {q.options.map((option, optIndex) => (
                  <label key={optIndex} style={styles.optionLabel}>
                    <input
                      type="radio"
                      name={`question-${q.id}`}
                      value={optIndex}
                      checked={testAnswers[q.id] === optIndex}
                      onChange={() => setTestAnswers({...testAnswers, [q.id]: optIndex})}
                      style={styles.radioInput}
                    />
                    <span style={styles.optionText}>{option}</span>
                  </label>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div style={styles.testFooter}>
          <button 
            style={{
              ...styles.submitTestButton,
              ...(Object.keys(testAnswers).length < questions.length ? styles.submitTestButtonDisabled : {})
            }}
            onClick={handleTestSubmit}
            disabled={Object.keys(testAnswers).length < questions.length}
          >
            Submit Test
          </button>
          <p style={styles.testFooterText}>
            {Object.keys(testAnswers).length} of {questions.length} questions answered
          </p>
        </div>
      </div>
    );
  };

  const SectionQuiz = () => {
    const questions = currentQuiz.questions;
    
    if (quizSubmitted) {
      const passed = quizScore >= 70;
      
      return (
        <div style={styles.quizResults}>
          <div style={styles.quizResultsCard}>
            {passed ? (
              <div style={styles.quizPassIcon}>✓</div>
            ) : (
              <div style={styles.quizFailIcon}>✗</div>
            )}
            <h2 style={styles.quizResultsTitle}>
              {passed ? 'Great Job!' : 'Try Again'}
            </h2>
            <div style={styles.quizScoreDisplay}>
              <span style={styles.quizScoreNumber}>{quizScore}%</span>
              <span style={styles.quizScoreLabel}>Your Score</span>
            </div>
            <p style={styles.quizResultsDescription}>
              {passed 
                ? `You've passed this quiz with ${quizScore}%! You can continue to the next lesson.`
                : `You need 70% to pass. Review the material and try again.`
              }
            </p>
            <div style={styles.quizResultsActions}>
              {passed ? (
                <button 
                  style={styles.continueButton}
                  onClick={closeQuiz}
                >
                  Continue to Next Lesson
                </button>
              ) : (
                <>
                  <button 
                    style={styles.retakeButton}
                    onClick={() => startQuiz(currentQuiz)}
                  >
                    Retake Quiz
                  </button>
                  <button 
                    style={styles.secondaryButton}
                    onClick={() => setShowQuiz(false)}
                  >
                    Review Material
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      );
    }

    return (
      <div style={styles.quizContainer}>
        <div style={styles.quizHeader}>
          <h2 style={styles.quizTitle}>{currentQuiz.title}</h2>
          <p style={styles.quizSubtitle}>
            {questions.length} Questions • Passing Score: 70%
          </p>
        </div>

        <div style={styles.questionsContainer}>
          {questions.map((q, index) => (
            <div key={q.id} style={styles.questionCard}>
              <h3 style={styles.questionText}>
                {index + 1}. {q.question}
              </h3>
              <div style={styles.optionsContainer}>
                {q.options.map((option, optIndex) => (
                  <label 
                    key={optIndex} 
                    style={{
                      ...styles.optionLabel,
                      ...(quizAnswers[q.id] === optIndex ? styles.optionLabelSelected : {})
                    }}
                  >
                    <input
                      type="radio"
                      name={`quiz-question-${q.id}`}
                      value={optIndex}
                      checked={quizAnswers[q.id] === optIndex}
                      onChange={() => setQuizAnswers({...quizAnswers, [q.id]: optIndex})}
                      style={styles.radioInput}
                    />
                    <span style={styles.optionText}>{option}</span>
                  </label>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div style={styles.quizFooter}>
          <button 
            style={{
              ...styles.submitQuizButton,
              ...(Object.keys(quizAnswers).length < questions.length ? styles.submitQuizButtonDisabled : {})
            }}
            onClick={handleQuizSubmit}
            disabled={Object.keys(quizAnswers).length < questions.length}
          >
            Submit Quiz
          </button>
          <button 
            style={styles.cancelButton}
            onClick={() => setShowQuiz(false)}
          >
            Cancel
          </button>
          <p style={styles.quizFooterText}>
            {Object.keys(quizAnswers).length} of {questions.length} questions answered
          </p>
        </div>
      </div>
    );
  };

  const HelpArticles = () => (
    <div style={styles.helpContainer}>
      {selectedArticle ? (
        <ArticleView article={selectedArticle} />
      ) : showArticleEditor ? (
        <ArticleEditor />
      ) : (
        <>
          <div style={styles.helpHeader}>
            <h2 style={styles.helpTitle}>Resources & Support</h2>
            <button style={styles.createArticleButton} onClick={handleCreateArticle}>
              + Create Article
            </button>
          </div>
          <div style={styles.articlesGrid}>
            {articles.map(article => (
              <div key={article.id} style={styles.articleCard} onClick={() => setSelectedArticle(article)}>
                <div style={styles.articleCategory}>{article.category}</div>
                <h3 style={styles.articleTitle}>{article.title}</h3>
                <div style={styles.articleFooter}>
                  <span style={styles.articleReadTime}>{article.readTime}</span>
                  <span style={styles.articleLink}>Read More →</span>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );

  const ArticleView = ({ article }) => (
    <div style={styles.articleViewContainer}>
      <button 
        style={styles.backButton}
        onClick={() => setSelectedArticle(null)}
      >
        ← Back to Articles
      </button>
      
      <div style={styles.articleViewHeader}>
        <div style={styles.articleViewCategory}>{article.category}</div>
        <h1 style={styles.articleViewTitle}>{article.title}</h1>
        <div style={styles.articleViewMeta}>
          <span style={styles.articleViewReadTime}>📖 {article.readTime}</span>
          <div style={styles.articleActions}>
            <button 
              style={styles.editArticleButton}
              onClick={() => handleEditArticle(article)}
            >
              ✏️ Edit
            </button>
            <button 
              style={styles.deleteArticleButton}
              onClick={() => handleDeleteArticle(article.id)}
            >
              🗑️ Delete
            </button>
          </div>
        </div>
      </div>

      <div style={styles.articleViewContent}>
        {article.content ? (
          article.content.split('\n').map((paragraph, index) => (
            paragraph.trim() && <p key={index} style={styles.articleParagraph}>{paragraph}</p>
          ))
        ) : (
          <p style={styles.articleParagraph}>
            This is a placeholder article. Click "Edit" to add content to this article.
          </p>
        )}
      </div>
    </div>
  );

  const ArticleEditor = () => (
    <div style={styles.articleEditorContainer}>
      <div style={styles.editorHeader}>
        <h2 style={styles.editorTitle}>
          {editingArticle ? 'Edit Article' : 'Create New Article'}
        </h2>
        <div style={styles.editorActions}>
          <button 
            style={styles.cancelEditorButton}
            onClick={() => {
              setShowArticleEditor(false);
              setEditingArticle(null);
            }}
          >
            Cancel
          </button>
          <button 
            style={styles.saveArticleButton}
            onClick={handleSaveArticle}
          >
            {editingArticle ? 'Update Article' : 'Publish Article'}
          </button>
        </div>
      </div>

      <div style={styles.editorForm}>
        <div style={styles.formGroup}>
          <label style={styles.formLabel}>Title</label>
          <input
            type="text"
            style={styles.formInput}
            value={articleForm.title}
            onChange={(e) => setArticleForm({...articleForm, title: e.target.value})}
            placeholder="Enter article title..."
          />
        </div>

        <div style={styles.formRow}>
          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Category</label>
            <input
              type="text"
              style={styles.formInput}
              value={articleForm.category}
              onChange={(e) => setArticleForm({...articleForm, category: e.target.value})}
              placeholder="e.g., Study Tips, Events, Support"
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Read Time</label>
            <input
              type="text"
              style={styles.formInput}
              value={articleForm.readTime}
              onChange={(e) => setArticleForm({...articleForm, readTime: e.target.value})}
              placeholder="e.g., 5 min read"
            />
          </div>
        </div>

        <div style={styles.formGroup}>
          <label style={styles.formLabel}>Content</label>
          <textarea
            style={styles.formTextarea}
            value={articleForm.content}
            onChange={(e) => setArticleForm({...articleForm, content: e.target.value})}
            placeholder="Write your article content here... (Use line breaks to separate paragraphs)"
            rows={15}
          />
        </div>

        <div style={styles.editorFooter}>
          <p style={styles.editorHint}>
            💡 Tip: Press Enter twice to create a new paragraph
          </p>
        </div>
      </div>
    </div>
  );


function ProfileModal({ onClose }) {
  const [username, setUsername] = useState(localStorage.getItem("user_name") || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [tempacademyid, settempacademyid] = useState(localStorage.getItem('academyid'));
  
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    
    

    setError('');
    setSuccess(false);

    if (!username.trim()) {
      setError('Username cannot be empty');
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("username", username);
    formData.append("academyid", tempacademyid);
      custom_api_func
      .post(`api/updateusername/${tempacademyid}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "X-CSRFToken": csrftoken
        }
      }).then((response) => {
        localStorage.setItem('user_name', response.data.user_name);
    })
    .catch(error => {
        console.log("handleQuizSubmit error", error);
      });

  };

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(10,10,20,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000,
        padding: '20px',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: '#ffffff',
          borderRadius: '16px',
          width: '100%',
          maxWidth: '440px',
          boxShadow: '0 12px 32px rgba(10,10,20,0.2)',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '20px 24px',
            borderBottom: '1px solid rgba(10,10,20,0.08)',
          }}
        >
          <h2
            style={{
              fontSize: '20px',
              fontWeight: 600,
              color: '#131318',
              margin: 0,
            }}
          >
            Edit Profile 
          </h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '4px',
              display: 'flex',
            }}
          >
            <X size={22} color="#8b8b96" />
          </button>
        </div>

        <form
          onSubmit={handleSubmit}
          style={{
            padding: '24px',
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
          }}
        >
          

          <label
            htmlFor="username"
            style={{
              fontSize: '13px',
              fontWeight: 600,
              color: '#131318',
              marginBottom: '6px',
              marginTop: '12px',
            }}
          >
            Username
          </label>
          <input
            id="username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Enter your username"
            disabled={loading}
            style={{
              padding: '12px 14px',
              borderRadius: '10px',
              border: '1px solid rgba(10,10,20,0.15)',
              fontSize: '15px',
              color: '#131318',
              outline: 'none',
              boxSizing: 'border-box',
              width: '100%',
            }}
          />
          <span
            style={{
              fontSize: '12px',
              color: '#8b8b96',
              marginTop: '4px',
            }}
          >
            This is the name that will be displayed on all certifications.
          </span>

         <label
          htmlFor="email"
          style={{
            fontSize: '13px',
            fontWeight: 600,
            color: '#131318',
            marginBottom: '6px',
            marginTop: '12px',
          }}
        >
          Email
        </label>
          <input
            id="email"
            type="email"
            value={localStorage.getItem('useremail') || ''}
            disabled
            style={{
              padding: '12px 14px',
              borderRadius: '10px',
              border: '1px solid rgba(10,10,20,0.15)',
              fontSize: '15px',
              outline: 'none',
              backgroundColor: '#f5f5f7',
              color: '#8b8b96',
              cursor: 'not-allowed',
              boxSizing: 'border-box',
              width: '100%',
            }}
          />
          <span
            style={{
              fontSize: '12px',
              color: '#8b8b96',
              marginTop: '4px',
            }}
          >
            Email address can't be changed
          </span>

          {error && (
            <p
              style={{
                color: '#d32f2f',
                fontSize: '13px',
                marginTop: '10px',
                marginBottom: 0,
              }}
            >
              {error}
            </p>
          )}
          {success && (
            <p
              style={{
                color: '#2e7d32',
                fontSize: '13px',
                marginTop: '10px',
                marginBottom: 0,
              }}
            >
              Profile updated successfully!
            </p>
          )}

          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'flex-end',
              gap: '12px',
              marginTop: '24px',
            }}
          >
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              style={{
                padding: '10px 20px',
                borderRadius: '10px',
                border: '1px solid rgba(10,10,20,0.15)',
                backgroundColor: '#ffffff',
                color: '#131318',
                fontSize: '14px',
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Cancel
            </button>
            <button
             onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#402855'; }}
             onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#7c3aed'; }}
           
              type="submit"
              disabled={loading}
              style={{
                padding: '10px 24px',
                borderRadius: '10px',
                border: 'none',
                backgroundColor: '#7c3aed',
                color: '#ffffff',
                fontSize: '14px',
                fontWeight: 600,
                cursor: 'pointer',
                opacity: loading ? 0.6 : 1,
                ...(loading && { cursor: 'not-allowed' }),
              }}
            >
              {loading ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function ProfileDropdown() {

  const [tempusername,settempusername] = useState(localStorage.getItem("user_name"))
  const [tempuseremail,settempuseremail] = useState(localStorage.getItem("useremail"))
  const [showProfileModal, setShowProfileModal] = useState(false);

  return (
    <div style={styles.profileWrapper}>
      <button style={styles.profileButton} onClick={() => {
        setShowProfileModal(true);
        }}>
        <div style={{...styles.avatar,background:'#4A2E6B'}}>
          <User size={20} color="white" />
        </div>
        <div style={styles.profileText}>
          <span style={styles.profileName}>{tempusername}</span>
          <span style={styles.profileEmail}>{tempuseremail}</span>
        </div>

        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 4,
          marginLeft: 'auto',
          padding: '4px 8px',
          borderRadius: 6,
          background: 'rgba(74, 46, 107, 0.1)',
          color: '#4A2E6B',
          fontSize: 12,
          fontWeight: 500,
        }}>
          <Pencil size={12} color='#4A2E6B'/>
          <span>Edit Profile</span>
        </div>
        
      </button>

      {showProfileModal && (
        <ProfileModal
          onClose={() => setShowProfileModal(false)}
        />
      )}
    </div>
  );
}
 
  return (
    <>
    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=Inter:wght@400;500;600;700&family=IBM+Plex+Mono:wght@500&display=swap');

      :root {
        --font-display: 'Space Grotesk', sans-serif;
        --font-body: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        --font-mono: 'IBM Plex Mono', monospace;
        --sg-bg: #f7f7fa;
        --sg-bg-alt: #eef0f4;
        --sg-surface: #ffffff;
        --sg-surface-2: #f1f2f6;
        --sg-border: rgba(10,10,20,0.08);
        --sg-border-strong: rgba(10,10,20,0.16);
        --sg-text: #131318;
        --sg-text-dim: #5c5d70;
        --sg-text-faint: #9a9bab;
        --sg-violet: #7c3aed;
        --sg-violet-soft: rgba(124,58,237,0.08);
        --sg-blue: #2563eb;
        --sg-green: #059669;
        --sg-green-soft: rgba(5,150,105,0.08);
        --sg-amber: #d97706;
        --sg-amber-soft: rgba(217,119,6,0.08);
        --sg-red: #e11d48;
        --sg-red-soft: rgba(225,29,72,0.08);
        --sg-shadow-rest: 0 1px 2px rgba(10,10,20,0.04);
        --sg-shadow-elevated: 0 20px 40px rgba(10,10,20,0.08);
        --sg-gradient: linear-gradient(135deg, #7c3aed, #2563eb);
      }

      .sg-academy, .sg-academy *, .sg-academy *::before, .sg-academy *::after {
        box-sizing: border-box;
      }

      .sg-academy {
        max-width: 100vw;
        overflow-x: hidden;
      }

      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(30px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      @keyframes fadeInScale {
        from {
          opacity: 0;
          transform: scale(0.8);
        }
        to {
          opacity: 1;
          transform: scale(1);
        }
      }

      @keyframes drawBorder {
        0% {
          clip-path: polygon(0 0, 0 0, 0 100%, 0 100%);
        }
        25% {
          clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
        }
        50% {
          clip-path: polygon(0 0, 100% 0, 100% 100%, 100% 100%);
        }
        75% {
          clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
        }
        100% {
          clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
        }
      }

      @keyframes particleFloat {
        0%, 100% {
          opacity: 0;
          transform: translateY(0) scale(1);
        }
        50% {
          opacity: 0.8;
          transform: translateY(-30px) scale(1.5);
        }
      }

      @keyframes pulse {
        0%, 100% {
          transform: translate(-50%, -50%) scale(1);
          opacity: 0.5;
        }
        50% {
          transform: translate(-50%, -50%) scale(1.2);
          opacity: 0.8;
        }
      }

      @keyframes barPulse {
        0%, 100% {
          transform: scaleY(0.5);
        }
        50% {
          transform: scaleY(1);
        }
      }

      .skipButton:hover {
        background-color: rgba(255, 255, 255, 0.3);
        transform: scale(1.05);
      }

      .playingBar:nth-child(2) {
        animation-delay: 0.2s;
      }

      .playingBar:nth-child(3) {
        animation-delay: 0.4s;
      }

      .sg-academy button:focus-visible,
      .sg-academy input:focus-visible,
      .sg-academy textarea:focus-visible,
      .sg-academy select:focus-visible,
      .sg-academy div[role="button"]:focus-visible {
        outline: 2px solid #7c3aed;
        outline-offset: 2px;
      }

      .sg-academy .sg-course-card:hover,
      .sg-academy .sg-article-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 20px 40px rgba(10,10,20,0.08);
      }

      .sg-academy .sg-nav-item:hover {
        background-color: rgba(255,255,255,0.08);
      }

      @media (prefers-reduced-motion: reduce) {
        .sg-academy *, .sg-academy *::before, .sg-academy *::after {
          animation-duration: 0.01ms !important;
          animation-iteration-count: 1 !important;
          transition-duration: 0.01ms !important;
        }
      }
    `}</style>
    <Toaster />
    {loading ? (
      <LoadingScreen />
    ):(
    <div className="sg-academy" style={styles.container}>
       
      {selectedCourse && activeTab=='courses' ? (
      <></>
      ):(
        <>
        {isMobile && sidebarOpen && (
        <div 
          style={styles.overlay}
          onClick={() => setSidebarOpen(false)}
        />

      )}
        <Sidebar />

        </>
      )}
      
      <div style={styles.mainContent}>
        <div style={styles.topBar}>
           {selectedCourse && activeTab=='courses' ? (
          null
          ):(
            <>
           {(isMobile || isTablet) && (

            <button 
              style={styles.menuButton}
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              <Menu size={24} />
            </button>
          )}
          </>)}
          <h1 style={styles.pageTitle}>
            {showTest ? 'Certification Test' : 
             selectedArticle ? selectedArticle.title :
             showArticleEditor ? (editingArticle ? 'Edit Article' : 'Create Article') :
             selectedCourse ? selectedCourse.title : 
             activeTab=='certificates' ? 'My Certificates' :
             'Home'}
          </h1>
          {(isMobile || isTablet) && (selectedCourse && activeTab=='courses' ) ? (
            null
          ):(
            <ProfileDropdown />
          )}
          
        </div>
        
        <div style={styles.mainLayout}>
          <div style={styles.contentArea}>
            {(showTest && activeTab=='courses') ? (
              <CertificationTest />
            ) : (selectedCourse && activeTab=='courses') ? (
              <CourseDetail />
              
            ) : (
              <>
              {activeTab == 'courses' && (
                <div style={styles.tabs}>
                  <button 
                    style={{...styles.tab, ...(activeTab === 'courses' ? styles.tabActive : {})}}
                    onClick={() => {
                      setActiveTab('courses');
                      setSelectedArticle(null);
                      setShowArticleEditor(false);
                    }}
                  >
                    Courses
                  </button>
                  {/* 
                  <button 
                    style={{...styles.tab, ...(activeTab === 'help' ? styles.tabActive : {})}}
                    onClick={() => {
                      setActiveTab('help');
                      setSelectedArticle(null);
                      setShowArticleEditor(false);
                    }}
                  >
                    Help & Resources
                  </button>
                  */}
                </div>
              )}

                {activeTab === 'courses' && (
                  <CoursesList />
                )}

                {activeTab === 'help' && (
                  <HelpArticles />
                )}

                {activeTab === 'certificates' && (
                  <MyCertificates
                    certifications={Object.values(allcertifications)}
                    onDownload={downloadCertificate}
                  />
                )}

              </>
            )}
          </div>

          

          
        </div>
      

        {showSupportModal && (
        <div style={ticket_styles.modalOverlay} onClick={handleCloseModal}>
          <div style={ticket_styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div style={ticket_styles.modalHeader}>
              <h2 style={ticket_styles.modalTitle}>Submit Support Ticket</h2>
              <button
                style={{
                  ...ticket_styles.closeButton,
                  ...(hoveredClose ? ticket_styles.closeButtonHover : {})
                }}
                onMouseEnter={() => setHoveredClose(true)}
                onMouseLeave={() => setHoveredClose(false)}
                onClick={handleCloseModal}
              >
                <FaTimes size={20} />
              </button>
            </div>
            
            <div style={ticket_styles.modalBody}>
              {submitSuccess && (
                <div style={ticket_styles.successMessage}>
                  <span style={{ fontSize: '20px' }}>✓</span>
                  <span>Your support ticket has been submitted successfully! We'll get back to you soon.</span>
                </div>
              )}

              <div style={ticket_styles.formGroup}>
                <label style={ticket_styles.label}>
                  Subject<span style={ticket_styles.required}>*</span>
                </label>
                <input
                  type="text"
                  placeholder="Brief description of your issue"
                  value={ticketForm.subject}
                  onChange={(e) => handleFormChange('subject', e.target.value)}
                  onFocus={() => setFocusedField('subject')}
                  onBlur={() => setFocusedField(null)}
                  style={{
                    ...ticket_styles.input,
                    ...(focusedField === 'subject' ? ticket_styles.inputFocus : {})
                  }}
                  required
                />
              </div>

              <div style={ticket_styles.formGroup}>
                <label style={ticket_styles.label}>
                  Category<span style={ticket_styles.required}>*</span>
                </label>
                <select
                  className='form-select'
                  value={ticketForm.category}
                  onChange={(e) => handleFormChange('category', e.target.value)}
                  onFocus={() => setFocusedField('category')}
                  onBlur={() => setFocusedField(null)}
                  style={{
                    ...ticket_styles.select,
                    ...(focusedField === 'category' ? ticket_styles.inputFocus : {})
                  }}
                  required
                >
                  <option value="">Select a category</option>
                  <option value="technical">Technical Issue</option>
                  <option value="account">Account & Billing</option>
                  <option value="feature">Feature Request</option>
                  <option value="bug">Bug Report</option>
                  <option value="data">Data & Integration</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div style={ticket_styles.formGroup}>
                <label style={ticket_styles.label}>Priority</label>
                <div style={ticket_styles.priorityGrid}>
                  {['low', 'medium', 'high'].map((priority) => (
                    <div
                      key={priority}
                      onClick={() => handleFormChange('priority', priority)}
                      style={{
                        ...ticket_styles.priorityOption,
                        ...(ticketForm.priority === priority ? ticket_styles.priorityOptionSelected : {})
                      }}
                    >
                      {priority.charAt(0).toUpperCase() + priority.slice(1)}
                    </div>
                  ))}
                </div>
              </div>

              <div style={ticket_styles.formGroup}>
                <label style={ticket_styles.label}>
                  Description<span style={ticket_styles.required}>*</span>
                </label>
                <textarea
                  placeholder="Please provide detailed information about your issue..."
                  value={ticketForm.description}
                  onChange={(e) => handleFormChange('description', e.target.value)}
                  onFocus={() => setFocusedField('description')}
                  onBlur={() => setFocusedField(null)}
                  style={{
                    ...ticket_styles.textarea,
                    ...(focusedField === 'description' ? ticket_styles.inputFocus : {})
                  }}
                  required
                />
                <div style={ticket_styles.helperText}>
                  Include steps to reproduce, error messages, or any relevant details
                </div>
              </div>

              <button
                onClick={handleSubmitTicket}
                disabled={!isFormValid || isSubmitting}
                onMouseEnter={() => setHoveredSubmit(true)}
                onMouseLeave={() => setHoveredSubmit(false)}
                style={{
                  ...ticket_styles.submitButton,
                  ...(hoveredSubmit && isFormValid && !isSubmitting ? ticket_styles.submitButtonHover : {}),
                  ...(!isFormValid || isSubmitting ? ticket_styles.submitButtonDisabled : {})
                }}
              >
                {isSubmitting ? (
                  <>
                    <div className="spinner"></div>
                    <span>Submitting...</span>
                  </>
                ) : (
                  <>
                    <FaPaperPlane />
                    <span>Submit Ticket</span>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      </div>
    </div>
    )}
    </>
  );
};


const styles = {
  container: {
    display: 'flex',
    height: '100vh',
    backgroundColor: '#f7f7fa',
    fontFamily: 'var(--font-body)',
    position: 'relative',
    overflow: 'hidden',
  },
  sidebar: {
    width: 'min(260px, 82vw)',
    backgroundColor: '#7c3aed',
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '2px 0 10px rgba(10,10,20,0.06)',
    flexShrink: 0,
  },
  filterContainer: {
  marginBottom: '24px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px'
},
searchInput: {
  padding: '12px 16px',
  fontSize: '14px',
  fontFamily: 'var(--font-body)',
  border: '1px solid rgba(10,10,20,0.16)',
  borderRadius: '8px',
  outline: 'none',
  transition: 'border-color 0.2s',
  backgroundColor: '#ffffff',
  color: '#131318',
  width: '100%',
  boxSizing: 'border-box',
},
categoryTabs: {
  display: 'flex',
  gap: '8px',
  flexWrap: 'wrap'
},
categoryTab: {
  padding: '8px 20px',
  fontSize: '14px',
  fontFamily: 'var(--font-body)',
  border: '1px solid rgba(10,10,20,0.16)',
  borderRadius: '20px',
  background: 'white',
  color: '#5c5d70',
  cursor: 'pointer',
  transition: 'all 0.2s',
  outline: 'none'
},
categoryTabActive: {
  background: '#7c3aed',
  color: 'white',
  borderColor: '#7c3aed'
},
noResults: {
  textAlign: 'center',
  padding: '40px',
  color: '#9a9bab',
  fontSize: '16px'
},
  sidebarHeader: {
     padding: '20px',
    borderBottom: '1px solid rgba(255,255,255,0.14)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    minWidth: 0,
  },
  logoIcon: {
    fontSize: '24px',
    flexShrink: 0,
  },
  logoText: {
    fontSize: '20px',
    fontFamily: 'var(--font-display)',
    fontWeight: '600',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  userProfile: {
    padding: '20px',
    borderBottom: '1px solid rgba(255,255,255,0.14)',
  },
  avatar: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: '#e11d48',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: '600',
    marginBottom: '10px',
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: '14px',
  },
  userEmail: {
    opacity: 0.9,
  },
  nav: {
    flex: 1,
    padding: '20px 0',
  },
  navItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 20px',
    cursor: 'pointer',
    transition: 'background 0.2s',
    fontSize: '14px',
    fontFamily: 'var(--font-body)',
  },
  navItemActive: {
    backgroundColor: 'rgba(255,255,255,0.12)',
    borderLeft: '3px solid #fff',
  },
  iconWrapper: {
    width: '20px',
    height: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  sidebarFooter: {
    padding: '20px 0',
    borderTop: '1px solid rgba(255,255,255,0.14)',
  },
  mainContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    minWidth: 0,
  },
  topBar: {
    backgroundColor: '#ffffff',
    padding: 'clamp(12px, 3vw, 16px) clamp(14px, 4vw, 20px)',
    borderBottom: '1px solid rgba(10,10,20,0.08)',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    flexWrap: 'wrap',
  },
  menuButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#131318',
    flexShrink: 0,
  },
  pageTitle: {
    fontSize: 'clamp(18px, 5vw, 24px)',
    fontFamily: 'var(--font-display)',
    fontWeight: '600',
    color: '#131318',
    margin: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
    flex: '1 1 auto',
  },
    profileWrapper: {
    position: 'relative',
    marginLeft: 'auto',
    flexShrink: 0,
  },
  profileButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '6px 8px',
    borderRadius: '10px',
  },
  avatar: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: '#e8e8ec',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  profileText: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    lineHeight: 1.2,
  },
  profileName: {
    fontSize: '15px',
    fontWeight: 600,
    color: '#131318',
  },
  profileEmail: {
    fontSize: '13px',
    color: '#8b8b96',
  },
  dropdownMenu: {
    position: 'absolute',
    top: 'calc(100% + 8px)',
    right: 0,
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 8px 24px rgba(10,10,20,0.15)',
    minWidth: '220px',
    overflow: 'hidden',
    zIndex: 1000,
  },
  dropdownItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    width: '100%',
    padding: '16px 20px',
    background: 'none',
    border: 'none',
    borderBottom: '1px solid rgba(10,10,20,0.06)',
    cursor: 'pointer',
    textAlign: 'left',
  },
  dropdownItemLast: {
    borderBottom: 'none',
  },
  dropdownItemText: {
    fontSize: '15px',
    color: '#131318',
  },
  mainLayout: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
    minWidth: 0,
  },
  contentArea: {
    flex: 1,
    overflow: 'auto',
    padding: 'clamp(16px, 4vw, 30px)',
    minWidth: 0,
  },
  rightSidebar: {
    width: '320px',
    backgroundColor: '#ffffff',
    borderLeft: '1px solid rgba(10,10,20,0.08)',
    overflow: 'auto',
    padding: '30px 20px',
  },
  rightSidebarSection: {
    marginBottom: '30px',
  },
  rightSidebarTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#131318',
    marginBottom: '16px',
  },
  courseProgressWidget: {
    backgroundColor: '#f1f2f6',
    borderRadius: '12px',
    padding: '20px',
    textAlign: 'center',
  },
  courseProgressIcon: {
    fontSize: '40px',
    marginBottom: '12px',
  },
  courseProgressName: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#131318',
    marginBottom: '12px',
    lineHeight: '1.4',
  },
  courseProgressPercent: {
    fontSize: '32px',
    fontFamily: 'var(--font-mono)',
    fontWeight: '700',
    color: '#7c3aed',
    marginBottom: '12px',
  },
  progressBarContainer: {
    width: '100%',
    height: '8px',
    backgroundColor: '#f1f2f6',
    borderRadius: '4px',
    overflow: 'hidden',
  },
  progressBarFill: {
    height: '100%',
    backgroundColor: '#7c3aed',
    transition: 'width 0.3s ease',
  },
  resourcesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  resourceItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px',
    padding: '12px',
    backgroundColor: '#f1f2f6',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'background 0.2s',
  },
  resourceText: {
    fontSize: '13px',
    color: '#131318',
    lineHeight: '1.4',
    flex: 1,
  },
  tabs: {
    display: 'flex',
    gap: '5px',
    marginBottom: '30px',
    borderBottom: '2px solid rgba(10,10,20,0.08)',
    overflowX: 'auto',
  },
  tab: {
    padding: '12px 24px',
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    fontSize: '15px',
    fontFamily: 'var(--font-body)',
    fontWeight: '500',
    color: '#5c5d70',
    borderBottom: '3px solid transparent',
    transition: 'all 0.2s',
    whiteSpace: 'nowrap',
  },
  tabActive: {
    color: '#7c3aed',
    borderBottom: '3px solid #7c3aed',
  },
  coursesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 280px), 1fr))',
    gap: 'clamp(16px, 3vw, 24px)',
  },
  courseCard: {
    display: 'flex',
    flexDirection: 'column',
   
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: 'clamp(16px, 3vw, 24px)',
    cursor: 'pointer',
    transition: 'transform 0.2s, box-shadow 0.2s',
    boxShadow: '0 1px 2px rgba(10,10,20,0.04)',
    border: '1px solid rgba(10,10,20,0.08)',
    minWidth: 0,
  },
  courseCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
  },
  courseIcon: {
    fontSize: 'clamp(24px, 6vw, 32px)',
    backgroundColor: 'rgba(124,58,237,0.08)',
    width: 'clamp(50px, 12vw, 60px)',
    height: 'clamp(50px, 12vw, 60px)',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  
  courseProgress: {
    fontSize: 'clamp(16px, 4vw, 18px)',
    fontFamily: 'var(--font-mono)',
    fontWeight: '600',
    color: '#7c3aed',
  },
  courseTitle: {
    fontSize: 'clamp(16px, 4vw, 18px)',
    fontFamily: 'var(--font-display)',
    fontWeight: '600',
    color: '#131318',
    marginBottom: '8px',
    overflowWrap: 'anywhere',
  },
  courseDescription: {
    fontSize: 'clamp(13px, 3.5vw, 14px)',
    color: '#5c5d70',
    marginBottom: '16px',
    lineHeight: '1.5',
    overflowWrap: 'anywhere',
  },
  courseFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: 'clamp(12px, 3vw, 13px)',
    color: '#9a9bab',
    flexWrap: 'wrap',
    gap: '8px',
  },
  courseDuration: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontFamily: 'var(--font-mono)',
  },
  courseSections: {},
  courseDetail: {
    maxWidth: '1200px',
    margin: '0 auto',
  },
  backButton: {
    padding: '10px 20px',
    backgroundColor: '#ffffff',
    border: '1px solid rgba(10,10,20,0.16)',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontFamily: 'var(--font-body)',
    color: '#131318',
    marginBottom: '20px',
    transition: 'background 0.2s',
  },
  courseHeader: {
    background: 'linear-gradient(135deg, #7c3aed 0%, #2563eb 100%)',
    borderRadius: '12px',
    padding: 'clamp(24px, 5vw, 40px)',
    color: '#fff',
    marginBottom: '30px',
  },
  courseHeaderContent: {
    flex: 1,
  },
  courseHeaderTitle: {
    fontSize: 'clamp(24px, 6vw, 32px)',
    fontFamily: 'var(--font-display)',
    fontWeight: '700',
    marginBottom: '12px',
  },
  courseHeaderDescription: {
    fontSize: 'clamp(14px, 3.5vw, 16px)',
    marginBottom: '16px',
    opacity: 0.95,
  },
  courseHeaderInfo: {
    fontSize: '14px',
    lineHeight: '1.6',
    opacity: 0.9,
  },
  courseHeaderNote: {
  fontSize: '14px',
  color: '#131318',
  marginTop: '12px',
  padding: '12px 16px',
  backgroundColor: '#ffffff',
  borderRadius: '6px',
  borderLeft: '3px solid #7c3aed'
},
  courseProgressCard: {
    backgroundColor: 'rgba(255,255,255,0.2)',
    borderRadius: '12px',
    padding: '24px',
    textAlign: 'center',
    minWidth: '180px',
  },
  progressTitle: {
    fontSize: '14px',
    marginBottom: '16px',
    fontWeight: '500',
  },
  progressCircle: {
    width: '100px',
    height: '100px',
    borderRadius: '50%',
    backgroundColor: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
  },
  progressPercent: {
    fontSize: '28px',
    fontFamily: 'var(--font-mono)',
    fontWeight: '700',
    color: '#7c3aed',
  },
  videoPlayer: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: 'clamp(16px, 4vw, 24px)',
    marginBottom: '30px',
    boxShadow: '0 1px 2px rgba(10,10,20,0.04)',
    border: '1px solid rgba(10,10,20,0.08)',
  },
  videoPlayerContainer: {
    backgroundColor: '#000',
    borderRadius: '12px',
    overflow: 'hidden',
    marginBottom: '20px',
    position: 'relative',
    minHeight: 'clamp(300px, 50vw, 500px)',
    //aspectRatio: '16 / 9',
  },
  videoElement: {
    width: '100%',
    height: '100%',
    minHeight: 'clamp(300px, 50vw, 500px)',
    objectFit: 'contain',
    backgroundColor: '#000',
    display: 'block',
  },
  videoInfo: {
    backgroundColor: '#ffffff',
    padding: 'clamp(12px, 3vw, 20px)',
    borderTop: '1px solid rgba(10,10,20,0.08)',
  },
  nowPlayingTitle: {
    fontSize: 'clamp(16px, 4vw, 20px)',
    fontFamily: 'var(--font-display)',
    fontWeight: '600',
    color: '#131318',
    marginBottom: '8px',
    display: 'flex',
    alignItems: 'center',
  },
  videoDescription: {
    fontSize: 'clamp(12px, 3vw, 14px)',
    color: '#5c5d70',
    margin: 0,
  },
  videoControls: {
    display: 'flex',
    gap: 'clamp(8px, 2vw, 12px)',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  navButton: {
    padding: '10px clamp(12px, 3vw, 20px)',
    backgroundColor: '#ffffff',
    color: '#7c3aed',
    border: '2px solid #7c3aed',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: 'clamp(13px, 3.5vw, 14px)',
    fontFamily: 'var(--font-body)',
    fontWeight: '600',
    transition: 'all 0.2s',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  navButtonDisabled: {
    backgroundColor: '#f1f2f6',
    color: '#9a9bab',
    borderColor: 'rgba(10,10,20,0.16)',
    cursor: 'not-allowed',
  },
lessonProgress: {
  textAlign: 'center',
  fontSize: '13px',
  color: '#5c5d70',
  fontWeight: '500',
},
introOverlay: {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 10,
  borderRadius: '12px',
},
  playIcon: {
    marginBottom: '20px',
    opacity: 0.8,
  },
  videoTitle: {
    color: '#fff',
    fontSize: '20px',
    fontWeight: '500',
  },

  
 
  sectionProgress: {
    fontSize: '14px',
    fontFamily: 'var(--font-mono)',
    fontWeight: '600',
    color: '#7c3aed',
  },
  
    completeButton: {
    padding: '10px clamp(16px, 4vw, 20px)',
    backgroundColor: '#059669',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: 'clamp(13px, 3.5vw, 15px)',
    fontFamily: 'var(--font-body)',
    fontWeight: '600',
    transition: 'background 0.2s',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  sectionsContainer: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: 'clamp(16px, 4vw, 24px)',
    boxShadow: '0 1px 2px rgba(10,10,20,0.04)',
    border: '1px solid rgba(10,10,20,0.08)',
  },
  sectionsTitle: {
    fontSize: 'clamp(18px, 4.5vw, 20px)',
    fontFamily: 'var(--font-display)',
    fontWeight: '600',
    marginBottom: '20px',
    color: '#131318',
  },
  section: {
    marginBottom: '16px',
    border: '1px solid rgba(10,10,20,0.08)',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  sectionHeader: {
    padding: 'clamp(12px, 3vw, 16px) clamp(16px, 4vw, 20px)',
    backgroundColor: '#f1f2f6',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    transition: 'background 0.2s',
  },
  sectionHeaderLeft: {
    flex: 1,
  },
  sectionTitle: {
    fontSize: 'clamp(14px, 3.5vw, 16px)',
    fontWeight: '600',
    color: '#131318',
    marginBottom: '4px',
  },
  sectionInfo: {
    fontSize: 'clamp(12px, 3vw, 13px)',
    color: '#5c5d70',
  },
  sectionHeaderRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  lessonsList: {
    padding: '8px 0',
  },
  lessonItem: {
    padding: 'clamp(10px, 2.5vw, 12px) clamp(16px, 4vw, 20px)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'background 0.2s',
  },
  lessonLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flex: 1,
  },
  lessonTitle: {
    fontSize: 'clamp(13px, 3.5vw, 14px)',
    color: '#131318',
  },
  lessonDuration: {
    fontSize: 'clamp(12px, 3vw, 13px)',
    color: '#9a9bab',
    fontFamily: 'var(--font-mono)',
    whiteSpace: 'nowrap',
  },
  certificationSection: {
    marginTop: '30px',
  },

  certificationCard: {
    backgroundColor: 'rgba(124,58,237,0.08)',
    borderRadius: '12px',
    padding: 'clamp(24px, 6vw, 40px)',
    textAlign: 'center',
  },
  certificationTitle: {
    fontSize: 'clamp(20px, 5vw, 24px)',
    fontFamily: 'var(--font-display)',
    fontWeight: '600',
    color: '#131318',
    marginTop: '16px',
    marginBottom: '24px',
  },
  
  certificationDescription: {
    fontSize: '15px',
    color: '#5c5d70',
    marginBottom: '24px',
    lineHeight: '1.6',
  },
  startTestButton: {
    padding: '14px 32px',
    backgroundColor: '#7c3aed',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: 'clamp(14px, 3.5vw, 16px)',
    fontFamily: 'var(--font-body)',
    fontWeight: '600',
    transition: 'background 0.2s',
  },
  testContainer: {
    maxWidth: '900px',
    margin: '0 auto',
  },
  testHeader: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: 'clamp(20px, 5vw, 30px)',
    marginBottom: '24px',
    boxShadow: '0 1px 2px rgba(10,10,20,0.04)',
    border: '1px solid rgba(10,10,20,0.08)',
    textAlign: 'center',
  },
  testTitle: {
    fontSize: 'clamp(22px, 5.5vw, 28px)',
    fontFamily: 'var(--font-display)',
    fontWeight: '600',
    color: '#131318',
  },
  testSubtitle: {
    fontSize: '15px',
    color: '#5c5d70',
  },
  questionsContainer: {
    marginBottom: '24px',
  },
  questionCard: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: 'clamp(16px, 4vw, 24px)',
    marginBottom: '16px',
    boxShadow: '0 1px 2px rgba(10,10,20,0.04)',
    border: '1px solid rgba(10,10,20,0.08)',
  },
  questionText: {
    fontSize: 'clamp(14px, 3.5vw, 16px)',
    fontWeight: '500',
    color: '#131318',
    marginBottom: '16px',
    lineHeight: '1.5',
  },
  optionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  
  optionLabel: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    padding: 'clamp(10px, 2.5vw, 12px) clamp(12px, 3vw, 16px)',
    backgroundColor: '#f1f2f6',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'background 0.2s',
    border: '2px solid transparent',
  },
  radioInput: {
    width: '18px',
    height: '18px',
    cursor: 'pointer',
    marginTop: '2px',
    flexShrink: 0,
    accentColor: '#7c3aed',
  },

  optionText: {
    fontSize: 'clamp(13px, 3.5vw, 14px)',
    color: '#131318',
    flex: 1,
    lineHeight: '1.5',
  },
  testFooter: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: 'clamp(16px, 4vw, 24px)',
    boxShadow: '0 1px 2px rgba(10,10,20,0.04)',
    border: '1px solid rgba(10,10,20,0.08)',
    textAlign: 'center',
  },
  submitTestButton: {
    width: '100%',
    maxWidth: '300px',
    padding: '14px 32px',
    backgroundColor: '#7c3aed',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: 'clamp(14px, 3.5vw, 16px)',
    fontFamily: 'var(--font-body)',
    fontWeight: '600',
    transition: 'background 0.2s',
  },
  submitTestButtonDisabled: {
    backgroundColor: '#e5e5ea',
    color: '#9a9bab',
    cursor: 'not-allowed',
  },

  testFooterText: {
    fontSize: '14px',
    color: '#5c5d70',
  },
  testResults: {
    maxWidth: '600px',
    margin: '0 auto',
  },
  testResultsCard: {
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    padding: 'clamp(30px, 7vw, 60px) clamp(20px, 5vw, 40px)',
    boxShadow: '0 20px 40px rgba(10,10,20,0.08)',
    border: '1px solid rgba(10,10,20,0.08)',
    textAlign: 'center',
  },
  testResultsTitle: {
    fontSize: 'clamp(24px, 6vw, 32px)',
    fontFamily: 'var(--font-display)',
    fontWeight: '700',
    color: '#131318',
    marginTop: '24px',
    marginBottom: '24px',
  },


  testScore: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '24px',
  },
  testScoreNumber: {
    fontSize: 'clamp(48px, 12vw, 72px)',
    fontFamily: 'var(--font-mono)',
    fontWeight: '700',
    color: '#7c3aed',
    lineHeight: 1,
  },
  testScoreLabel: {
    fontSize: '16px',
    color: '#5c5d70',
    marginTop: '8px',
  },
  testResultsDescription: {
    fontSize: '16px',
    color: '#5c5d70',
    lineHeight: '1.6',
    marginBottom: '32px',
  },
  testResultsActions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  downloadButton: {
    padding: '14px 32px',
    backgroundColor: '#059669',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: 'clamp(14px, 3.5vw, 16px)',
    fontFamily: 'var(--font-body)',
    fontWeight: '600',
    transition: 'background 0.2s',
  },
  secondaryButton: {
    padding: '14px 32px',
    backgroundColor: '#ffffff',
    color: '#7c3aed',
    border: '2px solid #7c3aed',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: 'clamp(14px, 3.5vw, 16px)',
    fontFamily: 'var(--font-body)',
    fontWeight: '600',
    transition: 'all 0.2s',
  },
  retakeButton: {
    padding: '14px 32px',
    backgroundColor: '#7c3aed',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: 'clamp(14px, 3.5vw, 16px)',
    fontFamily: 'var(--font-body)',
    fontWeight: '600',
    transition: 'background 0.2s',
  },
  helpContainer: {
    maxWidth: '1200px',
    margin: '0 auto',
  },
  helpTitle: {
    fontSize: '24px',
    fontFamily: 'var(--font-display)',
    fontWeight: '600',
    color: '#131318',
    marginBottom: '24px',
  },
  articlesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: '20px',
  },
  articleCard: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: '24px',
    cursor: 'pointer',
    transition: 'transform 0.2s, box-shadow 0.2s',
    boxShadow: '0 1px 2px rgba(10,10,20,0.04)',
    border: '1px solid rgba(10,10,20,0.08)',
  },
  articleCategory: {
    display: 'inline-block',
    padding: '4px 12px',
    backgroundColor: 'rgba(124,58,237,0.08)',
    color: '#7c3aed',
    borderRadius: '16px',
    fontSize: '12px',
    fontWeight: '600',
    marginBottom: '12px',
  },
  articleTitle: {
    fontSize: '16px',
    fontFamily: 'var(--font-display)',
    fontWeight: '600',
    color: '#131318',
    marginBottom: '16px',
    lineHeight: '1.4',
  },
  articleFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '13px',
  },
  articleReadTime: {
    color: '#9a9bab',
    fontFamily: 'var(--font-mono)',
  },
  articleLink: {
    color: '#7c3aed',
    fontWeight: '600',
  },
   quizContainer: {
    maxWidth: '800px',
    margin: '0 auto',
  },
  quizHeader: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: 'clamp(16px, 4vw, 24px)',
    marginBottom: '20px',
    boxShadow: '0 1px 2px rgba(10,10,20,0.04)',
    border: '1px solid rgba(10,10,20,0.08)',
    textAlign: 'center',
  },
  quizTitle: {
    fontSize: 'clamp(20px, 5vw, 24px)',
    fontFamily: 'var(--font-display)',
    fontWeight: '600',
    color: '#131318',
  },
  quizFooter: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: '20px',
    boxShadow: '0 1px 2px rgba(10,10,20,0.04)',
    border: '1px solid rgba(10,10,20,0.08)',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    alignItems: 'center',
  },
  quizSubtitle: {
    fontSize: '14px',
    color: '#5c5d70',
  },

  submitQuizButton: {
    width: '100%',
    maxWidth: '300px',
    padding: '12px 32px',
    backgroundColor: '#7c3aed',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: 'clamp(13px, 3.5vw, 15px)',
    fontFamily: 'var(--font-body)',
    fontWeight: '600',
    transition: 'background 0.2s',
  },
  submitQuizButtonDisabled: {
    backgroundColor: '#e5e5ea',
    color: '#9a9bab',
    cursor: 'not-allowed',
  },
  cancelButton: {
    padding: '12px 32px',
    backgroundColor: '#ffffff',
    color: '#5c5d70',
    border: '2px solid rgba(10,10,20,0.16)',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '15px',
    fontFamily: 'var(--font-body)',
    fontWeight: '600',
    transition: 'all 0.2s',
  },
  quizFooterText: {
    fontSize: '13px',
    color: '#5c5d70',
    margin: 0,
  },
  optionLabelSelected: {
    backgroundColor: 'rgba(124,58,237,0.08)',
    borderColor: '#7c3aed',
  },
  
  quizResults: {
    maxWidth: '600px',
    margin: '50px auto',
    padding: '0 20px',
  },
  quizResultsCard: {
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    padding: 'clamp(30px, 7vw, 40px)',
    boxShadow: '0 20px 40px rgba(10,10,20,0.08)',
    border: '1px solid rgba(10,10,20,0.08)',
    textAlign: 'center',
  },
  quizPassIcon: {
    width: 'clamp(60px, 15vw, 80px)',
    height: 'clamp(60px, 15vw, 80px)',
    borderRadius: '50%',
    backgroundColor: '#059669',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 'clamp(36px, 9vw, 48px)',
    fontWeight: '700',
    margin: '0 auto 20px',
  },
  quizFailIcon: {
    width: 'clamp(60px, 15vw, 80px)',
    height: 'clamp(60px, 15vw, 80px)',
    borderRadius: '50%',
    backgroundColor: '#e11d48',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 'clamp(36px, 9vw, 48px)',
    fontWeight: '700',
    margin: '0 auto 20px',
  },
  quizResultsTitle: {
    fontSize: 'clamp(22px, 5.5vw, 28px)',
    fontFamily: 'var(--font-display)',
    fontWeight: '700',
    color: '#131318',
    marginBottom: '20px',
  },
  quizScoreDisplay: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '20px',
  },

  quizScoreNumber: {
    fontSize: 'clamp(42px, 10vw, 56px)',
    fontFamily: 'var(--font-mono)',
    fontWeight: '700',
    color: '#7c3aed',
    lineHeight: 1,
  },
  quizScoreLabel: {
    fontSize: '14px',
    color: '#5c5d70',
    marginTop: '8px',
  },
  quizResultsDescription: {
    fontSize: '15px',
    color: '#5c5d70',
    lineHeight: '1.6',
    marginBottom: '24px',
  },
  quizResultsActions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    width: '100%',
  },
  continueButton: {
    padding: '12px 32px',
    backgroundColor: '#059669',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: 'clamp(13px, 3.5vw, 15px)',
    fontFamily: 'var(--font-body)',
    fontWeight: '600',
    transition: 'background 0.2s',
    width: '100%',
  },
// Intro Animation Styles
introContainer: {
  position: 'relative',
  background: 'linear-gradient(135deg, #7c3aed 0%, #2563eb 100%)',
  borderRadius: '12px',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden',
  padding: 'clamp(20px, 4vw, 40px)',
},
particle1: { left: '10%', top: '20%', animationDelay: '0s' },
particle2: { left: '20%', top: '80%', animationDelay: '0.5s' },
particle3: { left: '80%', top: '30%', animationDelay: '1s' },
particle4: { left: '70%', top: '70%', animationDelay: '1.5s' },
particle5: { left: '50%', top: '10%', animationDelay: '2s' },
particle6: { left: '90%', top: '90%', animationDelay: '2.5s' },





playingIndicator: {
  display: 'flex',
  gap: '8px',
  marginBottom: '20px',
},
playingBar: {
  width: '6px',
  height: '40px',
  backgroundColor: '#fff',
  borderRadius: '3px',
  animation: 'barPulse 1s ease-in-out infinite',
},



htmlPlayerWrapper: {
    position: 'relative',
      width: '100%',
      height: '500px',
      backgroundColor: '#fff',
      overflow: 'hidden', // Add this
  },
  htmlIframe: {
    width: '100%',
    height: '100%',
    border: 'none',
    display: 'block',
    transform: 'scale(0.8)',
    transformOrigin: 'top left', // Add this
    width: '120%', // Add this - compensates for scale
    height: '120%', // Add this - compensates for scale
  },
  audioControlsOverlay: {
    position: 'absolute',
    bottom: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 10,
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    borderRadius: '8px',
    padding: '10px 20px',
  },
  audioControls: {
    width: '400px',
    maxWidth: '90vw',
  },


lessonType: {
    fontSize: '13px',
    color: '#7c3aed',
    margin: 0,
    fontWeight: '500',
  },




  introParticles: {
    position: 'absolute',
    width: 'clamp(3px, 0.5vw, 4px)',
height: 'clamp(3px, 0.5vw, 4px)',
    top: 0,
    left: 0,
    pointerEvents: 'none',
  },
  particle: {
    position: 'absolute',
    width: 'clamp(3px, 0.5vw, 4px)',
height: 'clamp(3px, 0.5vw, 4px)',
    background: 'white',
    borderRadius: '50%',
    animation: 'particleFloat 3s ease-in-out infinite',
  },
  introContent: {
    textAlign: 'center',
    position: 'relative',
    zIndex: 1,
    width: '100%',
    maxWidth: '900px',
    padding: '0 clamp(16px, 4vw, 20px)',
  },
  introGlow: {
    position: 'absolute',
    width: 'clamp(200px, 50vw, 300px)',
    height: 'clamp(200px, 50vw, 300px)',
    background: 'radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, transparent 70%)',
    borderRadius: '50%',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    animation: 'pulse 3s ease-in-out infinite',
    pointerEvents: 'none',
  },
introLessonNumber: {
    fontSize: 'clamp(1rem, 4vw, 2rem)',
    fontFamily: 'var(--font-display)',
    letterSpacing: 'clamp(1px, 0.3vw, 3px)',
    color: 'white',
    fontWeight: '300',
    maxWidth: '100%',
    marginBottom: 'clamp(1.5rem, 5vw, 3rem)',
    animation: 'fadeInUp 0.8s ease forwards',
    lineHeight: '1.4',
    wordWrap: 'break-word',
  },
  introLessonBox: {
    position: 'relative',
    display: 'inline-block',
    padding: 0,
    marginTop: 'clamp(1rem, 3vw, 2rem)',
    maxWidth: '100%',
    width: '100%',
  },
  introLessonTitle: {
    fontSize: 'clamp(1.25rem, 5vw, 2.5rem)',
    fontFamily: 'var(--font-display)',
    fontWeight: '700',
    color: 'white',
    padding: '2rem 4rem',
    animation: 'fadeInScale 0.8s ease 0.5s forwards',
    textShadow: '2px 2px 20px rgba(0, 0, 0, 0.3)',
    opacity: 0,
    padding: 'clamp(1rem, 4vw, 2rem) clamp(1.5rem, 6vw, 4rem)',
    lineHeight: '1.3',
    wordWrap: 'break-word',
    hyphens: 'auto',
  },
  introBorderBox: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    border: 'clamp(2px, 0.4vw, 4px) solid rgba(255, 255, 255, 0.9)',
    borderRadius: 'clamp(12px, 2vw, 20px)',
    boxShadow: '0 10px 40px rgba(10,10,20,0.2)',
    animation: 'drawBorder 1.5s ease 0.8s forwards',
    clipPath: 'polygon(0 0, 0 0, 0 100%, 0 100%)',
  },
overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(10,10,20,0.5)',
    zIndex: 999,
  },
closeSidebarBtn: {
    background: 'none',
    border: 'none',
    color: 'white',
    cursor: 'pointer',
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
  },

  linkedInButton: {
  padding: '14px 32px',
  backgroundColor: '#0a66c2',
  color: '#fff',
  border: 'none',
  borderRadius: '8px',
  cursor: 'pointer',
  fontSize: 'clamp(14px, 3.5vw, 16px)',
  fontFamily: 'var(--font-body)',
  fontWeight: '600',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'background 0.2s',
},
shareModalOverlay: {
  position: 'fixed',
  top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(10,10,20,0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
  padding: '20px',
},
shareModalCard: {
  backgroundColor: '#ffffff',
  borderRadius: '16px',
  padding: '32px',
  maxWidth: '500px',
  width: '100%',
  boxShadow: '0 20px 40px rgba(10,10,20,0.15)',
},
shareModalTitle: {
  fontSize: '20px',
  fontFamily: 'var(--font-display)',
  fontWeight: '700',
  color: '#131318',
  marginBottom: '8px',
},
shareModalSubtitle: {
  fontSize: '14px',
  color: '#5c5d70',
  marginBottom: '16px',
  lineHeight: '1.5',
},
shareTextArea: {
  width: '100%',
  padding: '12px',
  borderRadius: '8px',
  border: '1px solid rgba(10,10,20,0.15)',
  fontSize: '14px',
  fontFamily: 'var(--font-body)',
  color: '#131318',
  resize: 'vertical',
  marginBottom: '20px',
  boxSizing: 'border-box',
},
shareModalActions: {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
},


};



const styles_2 = {
  // My Certificates Styles
  certificatesContainer: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '20px',
  },
  certificatesHeader: {
    marginBottom: '40px',
    textAlign: 'center',
  },
  certificatesTitle: {
    fontSize: 'clamp(24px, 5vw, 32px)',
    fontFamily: 'var(--font-display)',
    fontWeight: '700',
    color: '#131318',
    marginBottom: '8px',
  },
  certificatesSubtitle: {
    fontSize: '16px',
    color: '#5c5d70',
  },
  certificatesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 350px), 1fr))',
    gap: '24px',
  },
  certCard: {
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    overflow: 'hidden',
    boxShadow: '0 1px 2px rgba(10,10,20,0.04)',
    transition: 'transform 0.2s, box-shadow 0.2s',
    border: '1px solid rgba(10,10,20,0.08)',
  },
  certCardHeader: {
    background: 'linear-gradient(135deg, #7c3aed 0%, #2563eb 100%)',
    padding: '24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  certBadge: {
    backgroundColor: 'rgba(255,255,255,0.2)',
    borderRadius: '50%',
    padding: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  certVerified: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    backgroundColor: 'rgba(255,255,255,0.92)',
    padding: '6px 12px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '600',
    color: '#059669',
  },
  certCardBody: {
    padding: '24px',
  },
  certCourseName: {
    fontSize: '20px',
    fontFamily: 'var(--font-display)',
    fontWeight: '600',
    color: '#131318',
    marginBottom: '16px',
    lineHeight: '1.4',
    overflowWrap: 'anywhere',
  },
  certDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginBottom: '16px',
  },
  certDetail: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    fontFamily: 'var(--font-mono)',
    color: '#5c5d70',
  },
  certId: {
    fontSize: '12px',
    color: '#9a9bab',
    fontFamily: 'var(--font-mono)',
    marginTop: '12px',
    padding: '8px',
    backgroundColor: '#f1f2f6',
    borderRadius: '6px',
  },
  certCardFooter: {
    padding: '16px 24px',
    backgroundColor: '#f1f2f6',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    borderTop: '1px solid rgba(10,10,20,0.08)',
  },
  downloadBtn: {
    flex: '1 1 120px',
    padding: '10px 16px',
    backgroundColor: '#7c3aed',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontFamily: 'var(--font-body)',
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    transition: 'background 0.2s',
  },
  shareBtn: {
    flex: '1 1 120px',
    padding: '10px 16px',
    backgroundColor: '#ffffff',
    color: '#7c3aed',
    border: '2px solid #7c3aed',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontFamily: 'var(--font-body)',
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    transition: 'all 0.2s',
  },
  viewBtn: {
    flex: '1 1 120px',
    padding: '10px 16px',
    backgroundColor: '#ffffff',
    color: '#5c5d70',
    border: '2px solid rgba(10,10,20,0.16)',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontFamily: 'var(--font-body)',
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    transition: 'all 0.2s',
  },
  emptyState: {
    textAlign: 'center',
    padding: '80px 20px',
  },
  emptyTitle: {
    fontSize: '24px',
    fontFamily: 'var(--font-display)',
    fontWeight: '600',
    color: '#5c5d70',
    marginTop: '24px',
    marginBottom: '12px',
  },
  emptyDescription: {
    fontSize: '16px',
    color: '#9a9bab',
    maxWidth: '400px',
    margin: '0 auto',
  },
};

  const ticket_styles = {
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 2rem',
      height: '45px',
      background: 'transparent',
      position: 'sticky',
      top: 0,
      zIndex: 4001,
      border: "none"
    },
    leftSection: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      flex: 1,
      maxWidth: '500px'
    },
    searchContainer: {
      position: 'relative',
      width: '100%',
      marginLeft: "50px",
    },
    searchWrapper: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
    },
    searchIcon: {
      position: 'absolute',
      left: '12px',
      color: '#9a9bab',
      fontSize: '16px',
      pointerEvents: 'none'
    },
   filterContainer: {
    marginBottom: '24px',
  },
  searchInput: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '14px',
    fontFamily: 'var(--font-body)',
    border: '1px solid rgba(10,10,20,0.16)',
    borderRadius: '8px',
    outline: 'none',
    boxSizing: 'border-box',
  },
    searchInputFocus: {
      border: '1px solid #7c3aed',
      boxShadow: '0 0 0 3px rgba(124,58,237,0.12)'
    },
    dropdown: {
      position: 'absolute',
      top: 'calc(100% + 8px)',
      left: 0,
      right: 0,
      backgroundColor: '#ffffff',
      border: '1px solid rgba(10,10,20,0.08)',
      borderRadius: '8px',
      boxShadow: '0 20px 40px rgba(10,10,20,0.08)',
      maxHeight: '400px',
      overflowY: 'auto',
      zIndex: 5000
    },
    dropdownItem: {
      padding: '12px 16px',
      cursor: 'pointer',
      transition: 'background-color 0.15s ease',
      borderBottom: '1px solid #f1f2f6',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    dropdownItemHover: {
      backgroundColor: '#f1f2f6'
    },
    customerInfo: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px'
    },
    customerName: {
      fontSize: '14px',
      fontWeight: '600',
      color: '#131318'
    },
    customerDetails: {
      fontSize: '12px',
      color: '#5c5d70'
    },
    healthBadge: {
      padding: '4px 12px',
      borderRadius: '12px',
      fontSize: '11px',
      fontWeight: '600',
      color: '#ffffff',
      whiteSpace: 'nowrap'
    },
    noResults: {
      padding: '16px',
      textAlign: 'center',
      color: '#5c5d70',
      fontSize: '14px'
    },
    rightSection: {
      display: 'flex',
      alignItems: 'center',
      gap: '1.5rem'
    },
    streakContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      padding: '0.5rem 1rem',
      backgroundColor: 'rgba(217,119,6,0.08)',
      borderRadius: '8px',
      border: '1px solid #d97706',
      transition: 'all 0.2s ease',
      position: 'relative',
      height: "32px"
    },
    fireIcon: {
      fontSize: '16px',
    },
    streakCount: {
      fontSize: '14px',
      fontFamily: 'var(--font-mono)',
      fontWeight: '700',
      color: '#d97706',
      letterSpacing: '-0.3px'
    },
    streakLabel: {
      fontSize: '12px',
      fontWeight: '500',
      color: '#d97706',
      letterSpacing: '0.5px',
      margin: "2.5px"
    },
    helpButton: {
      cursor: 'pointer',
      padding: '8px',
      borderRadius: '8px',
      transition: 'all 0.2s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'transparent',
      border: 'none'
    },
    helpButtonHover: {
      backgroundColor: '#f1f2f6',
      transform: 'scale(1.05)'
    },
    userSection: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem',
      padding: '0.5rem 0.75rem',
      borderRadius: '8px',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease',
      border: '1px solid transparent'
    },
    avatar: {
      width: '30px',
      height: '30px',
      borderRadius: '50%',
      border: '2px solid rgba(10,10,20,0.08)',
      objectFit: 'cover',
      backgroundColor: '#f1f2f6'
    },
    userInfo: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '2px'
    },
    userName: {
      fontSize: '14px',
      fontWeight: '600',
      color: '#131318',
      lineHeight: '1.2'
    },
    modalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(10,10,20,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      backdropFilter: 'blur(4px)',
      padding: '16px',
      boxSizing: 'border-box',
    },
    modalContent: {
      backgroundColor: '#ffffff',
      borderRadius: '16px',
      width: '100%',
      maxWidth: '600px',
      maxHeight: '90vh',
      overflow: 'auto',
      boxShadow: '0 20px 40px rgba(10,10,20,0.08)',
      animation: 'slideUp 0.3s ease-out',
      boxSizing: 'border-box',
    },
    modalHeader: {
      padding: 'clamp(16px, 4vw, 24px) clamp(18px, 5vw, 32px)',
      borderBottom: '1px solid rgba(10,10,20,0.08)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'sticky',
      top: 0,
      backgroundColor: '#ffffff',
      zIndex: 1
    },
    modalTitle: {
      fontSize: '20px',
      fontFamily: 'var(--font-display)',
      fontWeight: '700',
      color: '#131318',
      margin: 0
    },
    closeButton: {
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      padding: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '8px',
      transition: 'all 0.2s ease',
      color: '#5c5d70'
    },
    closeButtonHover: {
      backgroundColor: '#f1f2f6',
      color: '#131318'
    },
    modalBody: {
      padding: 'clamp(20px, 5vw, 32px)'
    },
    formGroup: {
      marginBottom: '24px'
    },
    label: {
      display: 'block',
      fontSize: '14px',
      fontWeight: '600',
      color: '#131318',
      marginBottom: '8px'
    },
    required: {
      color: '#e11d48',
      marginLeft: '4px'
    },
    input: {
      width: '100%',
      padding: '12px 16px',
      fontSize: '14px',
      fontFamily: 'var(--font-body)',
      border: '1px solid rgba(10,10,20,0.16)',
      borderRadius: '8px',
      outline: 'none',
      transition: 'all 0.2s ease',
      boxSizing: 'border-box'
    },
    inputFocus: {
      border: '1px solid #7c3aed',
      boxShadow: '0 0 0 3px rgba(124,58,237,0.12)'
    },
    select: {
      width: '100%',
      padding: '12px 16px',
      fontSize: '14px',
      fontFamily: 'var(--font-body)',
      border: '1px solid rgba(10,10,20,0.16)',
      borderRadius: '8px',
      outline: 'none',
      transition: 'all 0.2s ease',
      backgroundColor: '#ffffff',
      cursor: 'pointer',
      boxSizing: 'border-box'
    },
    textarea: {
      width: '100%',
      padding: '12px 16px',
      fontSize: '14px',
      fontFamily: 'var(--font-body)',
      border: '1px solid rgba(10,10,20,0.16)',
      borderRadius: '8px',
      outline: 'none',
      transition: 'all 0.2s ease',
      minHeight: '120px',
      resize: 'vertical',
      boxSizing: 'border-box'
    },
    priorityGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '12px'
    },
    priorityOption: {
      padding: '12px',
      border: '2px solid rgba(10,10,20,0.08)',
      borderRadius: '8px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      textAlign: 'center',
      fontWeight: '600',
      fontSize: '14px',
      color: '#5c5d70',
    },
    priorityOptionSelected: {
      borderColor: '#7c3aed',
      backgroundColor: 'rgba(124,58,237,0.08)',
      color: '#7c3aed'
    },
    submitButton: {
      width: '100%',
      padding: '14px 24px',
      fontSize: '15px',
      fontFamily: 'var(--font-body)',
      fontWeight: '600',
      color: '#ffffff',
      backgroundColor: '#7c3aed',
      border: 'none',
      borderRadius: '8px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      marginTop: '32px'
    },
    submitButtonHover: {
      backgroundColor: '#6d28d9',
      transform: 'translateY(-1px)',
      boxShadow: '0 20px 40px rgba(124,58,237,0.25)'
    },
    submitButtonDisabled: {
      backgroundColor: '#e5e5ea',
      color: '#9a9bab',
      cursor: 'not-allowed',
      transform: 'none'
    },
    successMessage: {
      backgroundColor: 'rgba(5,150,105,0.08)',
      border: '1px solid #059669',
      borderRadius: '8px',
      padding: '16px',
      marginBottom: '24px',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      color: '#059669',
      fontSize: '14px',
      fontWeight: '500'
    },
    helperText: {
      fontSize: '12px',
      color: '#5c5d70',
      marginTop: '6px'
    }
  };

export default CRMLearningAcademy;